import { param } from "jquery";
import moment from "moment";
import { EMSHallMap } from "./HallMap";
import { is_empty } from "../../../ms_front_lib/utils";

export class EMSBasket {
    constructor() {
        this.data_basket = {
            "billetterie": {},
            "confiserie": {},
            "recharge": {},
            "vente_carte": {},
            "vente_carte_fidelite": {},
            "nb_place_total": 0,
            "nb_item_total": 0,
            "total" : 0,
            "mode_payment" : gl_ems_config.data_cinema.mode_PSP,
            "front" : "imsWeb"
        };

        if(localStorage.getItem("data_basket")){
            this.data_basket = JSON.parse(localStorage.getItem("data_basket"));
        }

        console.log("EMSBasket => this.data_basket", this.data_basket)
        // console.log(JSON.stringify(this.data_basket))
        // Si on a un panier et que le cinéma du panier est différent du cinéma en cours, on RAZ le panier
        if(this.data_basket.num_cine && this.data_basket.num_cine != gl_ems_config.data_cinema.num_cine){
            this.raz();
        }

        this.nb_place_max_basket = gl_ems_config.data_cinema.nb_place_max;

        this.data_movie = null;
        this.data_session = null;
        this.data_superbillet = null;
        this.data_item = null;
        this.data_cinema = null;
        this.data_cm = null;
        this.data_confiserie = null;

        this.is_session = false;
        this.is_superbillet = false;

        this.nb_tarif_en_cours=0;
        this.nb_tarif_exo_en_cours=0;
        this.nb_lunette_3D_en_cours=0;
        this.nb_codebarre_in_tab_cm_used=0;
        this.list_cm_used = [];
        this.nb_place_total = this.data_basket.nb_place_total ? this.data_basket.nb_place_total : 0;
        this.nb_item_total = this.data_basket.nb_item_total ? this.data_basket.nb_item_total : 0;
        this.multi_payment = false;
        this.multi_session = false;

        this.id_session = 0; // "id session" or "id superbillet"
        this.type_session = null // "session" or "superbillet"
        this.is_3d = false;
        this.is_3d_passive = false;
        this.seat_booking = false;

        this.montant_majo_externe_tot= 0;
        this.montant_majo_interne = 0;
        this.montant_lunette_externe = 0;

        this.id_movie = null;
        this.codebarre = null;
        this.item_id = 0;
        this.qty_to_modify = 1;

        this.menu_ref = null;
        this.tab_compo_menu = [];
        this.nb_item_en_cours = 0;
        this.tab_associated_product = [];
        this.id_confiserie_unit = localStorage.getItem("id_confiserie_unit") ? JSON.parse(localStorage.getItem("id_confiserie_unit")) : {};

        this.question_lunette_3D_passive = false;

        this.waiting_seats = []; // tableau des sièges sélectionnés en attente d'ajout de tarif au panier
        this.nb_waiting_seats = 0;

        this.suggestions_already_show = false;
        this.elem_from = null;

        this.pop_VO_shown = false;
        this.pop_certifications_shown = false;
    }

    async add(iParam) {
        // console.log("===== Basket.add =====", iParam)
        iParam.mode = "add";
        const self = this;
        const process_ok = await self.init_process(iParam);

        if(process_ok){
            switch(iParam.item_type){
                case "ticket":
                    self.add_ticket();
                    break;
                case "lunet_3d":
                    self.add_lunet_3d();
                    break;
                case "menu":
                case "product":
                    self.add_confiserie();
                    break;
                case "reload_subscription":
                    self.add_reload_subscription();
                    break;
                case "sell_subscription":
                    self.add_sell_subscription();
                    break;
                case "sell_fidelity":
                    self.add_sell_fidelity();
                    break;
                default:
                    break;
            }
        }

        return process_ok;
    }

    async add_confiserie() {
        const self = this;
        this.nb_item_total ++;

        this.data_basket.confiserie.mode_payment = "CB";

        if(this.data_basket.data_carte_abo){
            this.data_basket.data_carte_abo = await self.maj_virtual_solde_abo({
                "amount" : this.data_item.price,
                "basket_data_carte_abo" : this.data_basket.data_carte_abo,
                "data_cm" : this.data_basket.data_carte_abo.info,
                "mode" : "minus",
                "price" : this.data_item.price,
                "qty_to_modify" : 1,
                "type" : "confiserie"
            }); // js/fonction.js
        }

        // ===== Si il n'y a pas déjà un de ce type dans le panier (menu ou product) =====
        if(!(this.data_basket.confiserie[this.data_item.item_type])){
            this.data_basket.confiserie[this.data_item.item_type]={};
        }

        // ===== Si il n'y a pas déjà cet id confiserie =====
        if(!(this.data_basket.confiserie[this.data_item.item_type][this.data_item.id])){
            this.data_basket.confiserie[this.data_item.item_type][this.data_item.id]={};

            this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].qte=1;
            this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].id=this.data_item.id;
            this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].is_sold_out=this.data_item.is_sold_out;
            this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].label=this.data_item.label;
            this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].price=this.data_item.price;

            if(this.data_item.item_type == "menu"){
                this.menu_ref+="-0"; // premier menu avec cette composition
                
                this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].products = this.data_item.products;
                this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].ref_list={};
                this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].ref_list[this.menu_ref]={};
                this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].ref_list[this.menu_ref].products=this.tab_compo_menu;   // tableau qui contiendra la liste des produits du menu
            }
        }else{
            if(this.data_item.item_type == "menu"){
                var indice_ref=0;
                
                // ===== On récupère l'incide du dernier menu et on fait +1 =====
                $.each(this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].ref_list,function(key,value){
                    var tab_ref_list=key.split("-");
                    indice_ref=parseInt(tab_ref_list[1]);
                });
                
                indice_ref++;
                
                this.menu_ref+="-"+indice_ref;                        
                
                this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].ref_list[this.menu_ref]={};
                this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].ref_list[this.menu_ref].products=this.tab_compo_menu;   // tableau qui contiendra la liste des produits du menu
            }

            var new_qte=parseInt(this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].qte)+1;
            this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].qte=new_qte;
        }

        // ===== Si l'article a été ajouté suite à l'association à un tarif =====
        // if(data_item.associated_price && data_item.associated_price.length>0){
        //     data_basket.confiserie[item_type][item_id].associated_price = data_item.associated_price;
        // };


        // ===== Tableau unitaire des articles confiserie =====
        // ===== Sert pour le calcul auto des menus =====
        if(this.data_item.item_type == "product"){
            if(!this.id_confiserie_unit[this.data_item.id]){
                this.id_confiserie_unit[this.data_item.id] = {};
                this.id_confiserie_unit[this.data_item.id].qty = 1;
                this.id_confiserie_unit[this.data_item.id].id = this.data_item.id;
                this.id_confiserie_unit[this.data_item.id].label = this.data_item.label;
                this.id_confiserie_unit[this.data_item.id].price = this.data_item.price;
                this.id_confiserie_unit[this.data_item.id].associated_price = this.data_item.associated_price;
                this.id_confiserie_unit[this.data_item.id].is_sold_out = this.data_item.is_sold_out;
            }else{
                this.id_confiserie_unit[this.data_item.id].qty++;
            }
        }else if(this.data_item.item_type == "menu"){
            this.tab_compo_menu.forEach(product => {
                for(var q=0;q<product.qty;q++){
                    if(!this.id_confiserie_unit[product.ids[0]]){
                        this.id_confiserie_unit[product.ids[0]] = {};
                        this.id_confiserie_unit[product.ids[0]].qty = 1;
                        this.id_confiserie_unit[product.ids[0]].id = product.ids[0];
                        this.id_confiserie_unit[product.ids[0]].label = product.label;
                        this.id_confiserie_unit[product.ids[0]].price = product.price;
                    }else{
                        this.id_confiserie_unit[product.ids[0]].qty++;
                    }
                }
            });
        }

        localStorage.setItem("id_confiserie_unit",JSON.stringify(this.id_confiserie_unit));

        self.end_process();

        // ===== Si le cinéma veut que le calcul des menus soit automatique =====
        gl_app.EMSConfiserie.menu_auto();
    }

    async add_lunet_3d() {
        // i_log("===== Basket.add_lunet_3d =====")
        const self = this;

        // ===== Si paiement via carte abo, on va rajouter les infos de la carte à la racine du panier =====
        // ===== Ceci afin de les retrouver plus facilement dans le cas d'un achat de confiserie avec solde argent =====
        if(this.data_basket.data_carte_abo){
            var type_abonnement = this.data_basket.data_carte_abo.info.type_abo;
            let amount = 0.00;
            var nb_place_abo=0;

            for(var i=0;i<this.list_cm_used.length;i++){
                if(this.list_cm_used[i] == this.data_basket.data_carte_abo.num_cm){
                    nb_place_abo++;
                }
            } 
            
            switch(type_abonnement){
                case "A":       // Abonnement "argent"
                    var price_abo = this.data_basket.data_carte_abo.prix_place;

                    if(((this.nb_lunette_3D_en_cours+1)*(this.montant_lunette_externe))+(nb_place_abo*(price_abo+this.montant_majo_externe_tot))>this.data_basket.data_carte_abo.solde_argent){
                        Swal.fire({
                            icon:"info",
                            title:"",
                            text: _l("Le solde de votre carte est insuffisant"),
                            showCloseButton : true,
                            heightAuto : false,
                            scrollbarPadding : false,
                            allowOutsideClick : true,
                            customClass: {
                                icon : "align-items-center"
                            }
                        }); 
                        return;
                    };

                    this.data_basket.data_carte_abo = await self.maj_virtual_solde_abo({
                        "amount" : this.montant_lunette_externe,
                        "basket_data_carte_abo" : this.data_basket.data_carte_abo,
                        "data_cm" : this.data_basket.data_carte_abo.info,
                        "mode" : "minus",
                        "price" : price_abo,
                        "qty_to_modify" : this.qty_to_modify,
                        "type" : "ticket"
                    }); // js/fonction.js
                    break;
                case "M":       // Abonnement "mixte"
                    
                    break;
                default:
                    break;
            }
        }

        this.nb_lunette_3D_en_cours += this.qty_to_modify;
        this.nb_item_total += this.qty_to_modify;

        // ===== Si il n'y a pas déjà de lunette pour cette séance =====
        if(!(this.data_basket.billetterie[this.type_session][this.id_session].lunette)){
            this.data_basket.billetterie[this.type_session][this.id_session].lunette={};
        }

        this.data_basket.billetterie[this.type_session][this.id_session].lunette.qte = this.nb_lunette_3D_en_cours;
        this.data_basket.billetterie[this.type_session][this.id_session].lunette.prix = this.montant_lunette_externe;
        this.data_basket.billetterie[this.type_session][this.id_session].is_session_3D = this.is_3d;
        this.data_basket.billetterie[this.type_session][this.id_session].is_session_3D_passive = this.is_3d_passive;

        self.end_process();
    }

    add_reload_subscription() {
        // console.log("===== Basket.add_reload_subscription =====")
        const self = this;

        this.nb_item_total += 1;

        this.data_basket.recharge.scan_value = this.data_item.num_cm;
        this.data_basket.recharge.name = this.data_item.name;
        this.data_basket.recharge.type_abo = this.data_item.type_abo;
        this.data_basket.recharge.id_abonnement = this.data_item.id_abonnement;
        this.data_basket.recharge.prix_place = this.data_item.prix_place;
        this.data_basket.recharge.type_recharge = this.data_item.type_recharge;
        this.data_basket.recharge.solde_place = this.data_item.solde_place;
        this.data_basket.recharge.credit_argent = this.data_item.credit_argent;
        this.data_basket.recharge.frais_cine = this.data_item.frais_cine;
        this.data_basket.recharge.total = this.data_item.total;
        this.data_basket.recharge.multiplier = this.data_item.multiplier;

        self.end_process();
    }

    add_sell_subscription() {
        // console.log("===== Basket.add_sell_subscription =====", this.data_item)
        const self = this;

        this.nb_item_total += 1;

        this.data_basket.vente_carte.mode = "sell";
        if(this.data_item.scan_value){
            this.data_basket.vente_carte.scan_value = this.data_item.scan_value;
            this.data_basket.vente_carte.mode = "change";
        }
        this.data_basket.vente_carte.name = this.data_item.name;
        this.data_basket.vente_carte.type_abo = this.data_item.type_abo;
        this.data_basket.vente_carte.id_abonnement = this.data_item.id_abonnement;
        this.data_basket.vente_carte.prix_place = this.data_item.prix_place;
        this.data_basket.vente_carte.solde_place = this.data_item.solde_place;
        this.data_basket.vente_carte.solde_place_gratuite = this.data_item.solde_place_gratuite;
        this.data_basket.vente_carte.solde_place_illimitee = this.data_item.solde_place_illimitee;
        this.data_basket.vente_carte.credit_argent = this.data_item.credit_argent;
        this.data_basket.vente_carte.credit_argent_illimitee = this.data_item.credit_argent_illimitee;
        this.data_basket.vente_carte.frais_cine = this.data_item.frais_cine;
        this.data_basket.vente_carte.frais_support = this.data_item.frais_support;
        this.data_basket.vente_carte.total = this.data_item.total;
        this.data_basket.vente_carte.fidelity = this.data_item.fidelity;
        this.data_basket.vente_carte.user = this.data_item.user;

        self.end_process();
    }

    add_sell_fidelity() {
        // console.log("===== Basket.add_sell_fidelity =====", this.data_item)
        const self = this;

        this.nb_item_total += 1;

        this.data_basket.vente_carte_fidelite.name = this.data_item.name;
        this.data_basket.vente_carte_fidelite.id_fidelite = this.data_item.id;
        this.data_basket.vente_carte_fidelite.total = this.data_item.total;
        this.data_basket.vente_carte_fidelite.user = this.data_item.user;

        self.end_process();
    }

    async add_ticket() {
        // console.log("===== Basket.add_ticket =====")
        const self = this;
        let new_qte = 0;
        let item_amount = this.data_item.amount;
        let item_majo_externe = this.data_item.majo_externe;

        // Pop up pour les films en VO
        // Pop up pour les films avec des avertissements ou interdictions
        if(gl_ems_config.data_cinema.show_popup_vo && (this.type_session=="session" && this.data_session.features.indexOf("vo")>=0 && !this.pop_VO_shown)){
            this.pop_VO_shown = true;
            this.question_lunette_3D_passive=true;

            let text = this.data_session.features.indexOf("subtitle") >= 0 ? _l("Êtes vous sur de vouloir acheter un billet en Version Originale Sous Titrée?") : _l("Êtes vous sur de vouloir acheter un billet en Version Originale?");

            Swal.fire({
                icon:"",
                title:"Film en VO",
                text: text,
                showCloseButton : true,
                reverseButtons : true,
                showCancelButton: false,
                showDenyButton : true,
                confirmButtonText:_l("Oui"),
                denyButtonText : _l("Non"),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : true,
                customClass: {
                    icon : "align-items-center"
                }
            }).then((result) => {
                if(result.isConfirmed){
                    if(gl_ems_config.data_cinema.show_popup_certification && (!this.pop_certifications_shown && this.data_movie && this.data_movie.certification && this.data_movie.certification.text && this.data_movie.certification.text != "Tous public")){
                        self.pop_certifications_shown = true;
                        Swal.fire({
                            icon:"",
                            title:this.data_movie.certification.text,
                            text: _l("Ce film a une interdiction ou avertissement d'âge, êtes-vous sur de vouloir continuer?"),
                            showCloseButton : true,
                            reverseButtons : true,
                            showCancelButton: false,
                            showDenyButton : true,
                            confirmButtonText:_l("Oui"),
                            denyButtonText : _l("Non"),
                            heightAuto : false,
                            scrollbarPadding : false,
                            allowOutsideClick : true,
                            customClass: {
                                icon : "align-items-center"
                            }
                        }).then(function(result){
                            if(result.isConfirmed){
                            }else if(result.isDenied){

                                self.pop_VO_shown = false;
                                self.pop_certifications_shown = false;
                                self.raz();
                                window.location.replace("#home");
                            }   
                        });
                    }
                }else if(result.isDenied){
                    self.pop_VO_shown = false;
                    self.pop_certifications_shown = false;
                    self.raz();
                    window.location.replace("#home");
                }   
            });
        }else if(gl_ems_config.data_cinema.show_popup_certification && (!this.pop_certifications_shown && this.data_movie && this.data_movie.certification && this.data_movie.certification.text && this.data_movie.certification.text != "Tous public")){
            this.pop_certifications_shown = true;
            Swal.fire({
                icon:"",
                title:this.data_movie.certification.text,
                text: _l("Ce film a une interdiction ou avertissement d'âge, êtes-vous sur de vouloir continuer?"),
                showCloseButton : true,
                reverseButtons : true,
                showCancelButton: false,
                showDenyButton : true,
                confirmButtonText:_l("Oui"),
                denyButtonText : _l("Non"),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : true,
                customClass: {
                    icon : "align-items-center"
                }
            }).then(function(result){
                if(result.isConfirmed){
                    // self.add_lunet_3d();
                }else if(result.isDenied){
                    self.pop_VO_shown = false;
                    self.pop_certifications_shown = false;
                    self.raz();
                    window.location.replace("#home");
                }   
            });
        }

        // if(gl_id_type_paiement == 1 || gl_id_type_paiement==16){
        //     localStorage.setItem("email_cm",data_cm.email)
        // }

        // ===== Si paiement via carte abo, on va rajouter les infos de la carte à la racine du panier =====
        // ===== Ceci afin de les retrouver plus facilement dans le cas d'un achat de confiserie avec solde argent =====
        if(this.data_item.id_type_payment == 1){
            var type_abonnement = this.data_cm.type_abo;

            let amount = 0.00;
            
            switch(type_abonnement){
                case "A":       // Abonnement "argent"
                    if(!this.data_cm.illimite_argent){
                        amount = (((this.qty_to_modify)*(item_amount+item_majo_externe))+(this.nb_lunette_3D_en_cours*this.montant_lunette_externe));
                    }
                    break;
                case "M":       // Abonnement "mixte"
                    if(!this.data_cm.illimite_place){
                        if(this.data_cm.solde_argent>0){
                            amount = (((this.qty_to_modify)*(item_majo_externe))+(this.nb_lunette_3D_en_cours*this.montant_lunette_externe));
                        }
                    }
                    break;
                default:
                    break;
            }

            this.data_basket.data_carte_abo = await self.maj_virtual_solde_abo({
                "amount" : amount,
                "basket_data_carte_abo" : this.data_basket.data_carte_abo,
                "data_cm" : this.data_cm,
                "mode" : "minus",
                "price" : item_amount,
                "qty_to_modify" : this.qty_to_modify,
                "type" : "ticket"
            }); // js/fonction.js
        
        }

        if(this.nb_tarif_exo_en_cours>0){
            this.nb_tarif_en_cours = this.nb_tarif_exo_en_cours;
        }

        this.nb_tarif_en_cours += this.qty_to_modify;
        this.nb_place_total += this.qty_to_modify;
        this.nb_item_total += this.qty_to_modify;

        // ===== Si il n'y a pas déjà un de ce type dans le panier =====
        if(!(this.data_basket.billetterie[this.type_session])){
            this.data_basket.billetterie[this.type_session]={};
        }

        // ===== Si il n'y a pas déjà cette séance ou ce superbillet =====
        if(!(this.data_basket.billetterie[this.type_session][this.id_session])){
            this.data_basket.billetterie[this.type_session][this.id_session]={};
            if(this.type_session=="session"){
                this.data_basket.billetterie[this.type_session][this.id_session].tarif={};
            }
        }

        // ===== Si superbillet, pas de tarif en particulier =====
        if(this.type_session=="superbillet"){
            if(this.data_basket.billetterie[this.type_session][this.id_session].qte){
                new_qte=parseInt(this.data_basket.billetterie[this.type_session][this.id_session].qte)+1;
                this.data_basket.billetterie[this.type_session][this.id_session].qte=new_qte;
                this.data_basket.billetterie[this.type_session][this.id_session].type_payment=this.data_item.id_type_payment;
            }else{
                this.data_basket.billetterie[this.type_session][this.id_session].qte=1;
                this.data_basket.billetterie[this.type_session][this.id_session].type_payment=this.data_item.id_type_payment;
                this.data_basket.billetterie[this.type_session][this.id_session].id_type_payment=this.data_item.id_type_payment;
                this.data_basket.billetterie[this.type_session][this.id_session].is_session_3D=this.is_3d;
                this.data_basket.billetterie[this.type_session][this.id_session].is_session_3D_passive=this.is_3d_passive;
                this.data_basket.billetterie[this.type_session][this.id_session].montant_majo_externe_tot=this.montant_majo_externe_tot;
                this.data_basket.billetterie[this.type_session][this.id_session].montant_majo_interne=this.montant_majo_interne;
                this.data_basket.billetterie[this.type_session][this.id_session].montant_lunette_externe=this.montant_lunette_externe;
                this.data_basket.billetterie[this.type_session][this.id_session].seat_booking=this.seat_booking;
                this.data_basket.billetterie[this.type_session][this.id_session].nb_session=this.data_superbillet.nb_session;
                this.data_basket.billetterie[this.type_session][this.id_session].amount=item_amount;
                this.data_basket.billetterie[this.type_session][this.id_session].data_superbillet=this.data_superbillet;
                this.data_basket.billetterie[this.type_session][this.id_session].hall_map_section = this.data_item.hall_map_section ? this.data_item.hall_map_section : null;
                
                var list_session={};
                this.data_superbillet.sessions.forEach(sb_session => {
                    list_session[sb_session.id]={};
                    list_session[sb_session.id].id_session=sb_session.id;
                    list_session[sb_session.id].seat_booking=sb_session.session_data.seat_booking ? sb_session.session_data.seat_booking : false;
                    list_session[sb_session.id].seats=[];
                    list_session[sb_session.id].id_movie=sb_session.movie_data.id;
                });
                this.data_basket.billetterie[this.type_session][this.id_session].list_session=list_session;

                if(!(this.data_basket.billetterie[this.type_session][this.id_session].seats)){
                    this.data_basket.billetterie[this.type_session][this.id_session].seats=[];
                };
            }

            // ===== On va regarder si il y a des waiting seats =====
            if(this.data_basket.waiting_seats && this.data_basket.waiting_seats[this.type_session] && this.data_basket.waiting_seats[this.type_session][this.id_session]){
                $.each(this.data_basket.waiting_seats[this.type_session][this.id_session].list_session,(k,v) => {
                    v.seats.forEach(s => {
                        let seat_name = s;
                        let seat_info = {};
                        seat_info.element = $("#seat_booking_session_id_"+k+" .img_seat."+seat_name);
                        seat_info.type = $("#seat_booking_session_id_"+k+" .img_seat."+seat_name).data("type");
                        seat_info.seat_name = seat_name;
                        seat_info.seat_section = undefined;
                        seat_info.is_session = false;
                        seat_info.is_superbillet = true;
                        seat_info.data_session = {"ems_id":k};
                        seat_info.data_superbillet = self.data_superbillet;
                        this.select_seat({
                            "seat_info":seat_info
                        });
                        v.seats.splice(0,1);
                        if(v.seats.length  <= 0){
                            delete this.data_basket.waiting_seats[this.type_session][this.id_session].list_session[k];
                        }
                    });
                });
            }
        }else{
            // ===== Si il y a déjà ce tarif pour la séance =====
            if(this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id]){

                // ===== Si c'est un tarif lié à une contremarque =====
                if(this.codebarre){
                    
                    // Permettra de cacher les tarifs CB si une contremarque (hors cinéday) est ajoutée au panier
                    if(this.data_item.id_type_payment!=8){
                        // gl_cm_in_basket=true;
                    }
                    
                    this.list_cm_used.push(this.codebarre);
                    
                    if(this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre]){
                        new_qte=parseInt(this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].qte)+this.qty_to_modify;
                        this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].qte=new_qte;
                    }else{
                        this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre]={};
                        this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].code=this.codebarre;
                        this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].data_cm={};
                        this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].data_cm.cm=this.data_cm;
                        if(this.data_item.data_cm.recharge){
                            this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].data_cm.recharge=this.data_item.data_cm.recharge;
                        }
                        this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].qte=this.qty_to_modify;
                    }
                }

                new_qte=parseInt(this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].qte)+this.qty_to_modify;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].qte=new_qte;
            }else{
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id]={};
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre={};

                // ===== Si c'est un tarif lié à une contremarque =====
                if(this.codebarre){
                    
                    // Permettra de cacher les tarifs CB si une contremarque (hors cinéday) est ajoutée au panier
                    if(this.data_item.id_type_payment!=8){
                        // gl_cm_in_basket=true;
                    }
                    
                    this.list_cm_used.push(this.codebarre);
                    
                    this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre]={};
                    this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].code=this.codebarre;
                    this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].data_cm={};
                    this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].data_cm.cm=this.data_cm;
                    if(this.data_item.data_cm.recharge){
                        this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].data_cm.recharge=this.data_item.data_cm.recharge;
                    }
                    this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].qte=this.qty_to_modify;
                }

                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].qte = this.qty_to_modify;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].seats = [];
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].amount = item_amount;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].id = this.data_item.id;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].type_payment = this.data_item.id_type_payment;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].id_type_payment = this.data_item.id_type_payment;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].comment = this.data_item.comment ? this.data_item.comment : null;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].name = this.data_item.short_name ? this.data_item.short_name : this.data_item.name;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].hall_map_section = this.data_item.hall_map_section ? this.data_item.hall_map_section : null;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].majo_externe = this.data_item.majo_externe;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].majo_interne = this.data_item.majo_interne;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].family = this.data_item.cnc_famille;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].cnc_famille = this.data_item.cnc_famille;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].type = this.data_item.type;
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].is_cm = this.data_item.is_cm;

                this.data_basket.billetterie[this.type_session][this.id_session].id_film=this.id_movie;
                this.data_basket.billetterie[this.type_session][this.id_session].is_session_3D=this.is_3d;
                this.data_basket.billetterie[this.type_session][this.id_session].is_session_3D_passive=this.is_3d_passive;
                this.data_basket.billetterie[this.type_session][this.id_session].montant_majo_externe_tot=this.montant_majo_externe_tot;
                this.data_basket.billetterie[this.type_session][this.id_session].montant_majo_interne=this.montant_majo_interne;
                this.data_basket.billetterie[this.type_session][this.id_session].montant_lunette_externe=this.montant_lunette_externe;
                this.data_basket.billetterie[this.type_session][this.id_session].seat_booking=this.seat_booking;
                this.data_basket.billetterie[this.type_session][this.id_session].data_session=this.data_session;
                delete this.data_movie.sessions;
                this.data_basket.billetterie[this.type_session][this.id_session].data_session.data_ms=this.data_movie;
                this.data_basket.billetterie[this.type_session][this.id_session].hall_id = this.data_session.hall_id;
                if(gl_ems_config.data_cinema.is_tournee){
                    // let external_hall_info = gl_init_app.data_cinema.external_halls[data_session.hall];
                    // data_basket.billetterie[type_session][id_session].hall_name = external_hall_info.name+" "+external_hall_info.city;
                }else{
                    this.data_basket.billetterie[this.type_session][this.id_session].hall_name = this.data_session.hall_name;
                }

                if(!(this.data_basket.billetterie[this.type_session][this.id_session].seats)){
                    this.data_basket.billetterie[this.type_session][this.id_session].seats=[];
                };
            }

            // ===== On va regarder si il y a des waiting seats =====
            if(this.data_basket.waiting_seats && this.data_basket.waiting_seats[this.type_session] && this.data_basket.waiting_seats[this.type_session][this.id_session] && this.data_basket.waiting_seats[this.type_session][this.id_session].seats && this.data_basket.waiting_seats[this.type_session][this.id_session].seats.length > 0){
                let seat_name = this.data_basket.waiting_seats[this.type_session][this.id_session].seats[0];
                let seat_info = {};
                seat_info.element = $(".img_seat."+seat_name);
                seat_info.type = $(".img_seat."+seat_name).data("type");
                seat_info.seat_name = seat_name;
                seat_info.seat_section = undefined;
                seat_info.is_session = true;
                seat_info.is_superbillet = false;
                seat_info.data_session = self.data_session;
                seat_info.data_superbillet = self.data_superbillet;
                this.select_seat({
                    "seat_info":seat_info
                });
                this.data_basket.waiting_seats[this.type_session][this.id_session].seats.splice(0,1);
                if(this.data_basket.waiting_seats[this.type_session][this.id_session].seats.length  <= 0){
                    delete this.data_basket.waiting_seats[this.type_session][this.id_session];
                }
            }

            // ===== Si il y a des produits associés =====
            if(this.tab_associated_product.length>0){
                this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].associated_product = this.tab_associated_product;
            }
        }

        self.end_process();

        // ===== Si séance 3D =====
        if(this.is_3d){
            // ===== Si salle 3D passive, on pose la question d'ajout de lunettes =====
            if(this.is_3d_passive && !(this.question_lunette_3D_passive)){
                this.question_lunette_3D_passive=true;
                Swal.fire({
                    icon:"",
                    title:"Lunettes 3D",
                    text: _l("Voulez-vous ajouter une paire de lunette 3D?"),
                    showCloseButton : true,
                    reverseButtons : true,
                    showCancelButton: false,
                    showDenyButton : true,
                    confirmButtonText:_l("Oui"),
                    denyButtonText : _l("Non"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : true,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then(function(result){
                    if(result.isConfirmed){
                        self.add_lunet_3d();
                    }else if(result.isDenied){
                        
                    }
                });             
            }else{
                // ===== Si 3D active, on ajoute automatiquement une paire de lunettes =====
                if(!(this.is_3d_passive)){
                    self.add_lunet_3d();
                };
            };
        };

        // ===== Produits associés au tarif =====
        for(var i=0;i<this.tab_associated_product.length;i++){

            let data_associated_product = null;
            data_associated_product = this.tab_associated_product[i];

            data_associated_product.item_type = "product";
            data_associated_product.associated_price = [];

            let p = Object.assign({});
            p.data_item = this.data_item;
            p.data_session = this.data_session;
            p.is_session = this.is_session;
            p.data_superbillet = this.data_superbillet;
            p.is_superbillet = this.is_superbillet;
            p.data_movie = this.data_movie;
            p.item_type = this.item_type;  

            data_associated_product.associated_price.push(p);

            gl_app.EMSConfiserie.select_item({
                "data_item" : data_associated_product
            });
        };
    }

    async bloque() {
        // console.log("===== Basket.bloque =====")
        const self = this;
        // console.log(this.data_basket)
        // return;
        
        let my_basket = this.data_basket;
        var parameters_api={};
        var is_call_api_ok=true; // Permet de dire si on peut effectuer l'appel soap ou non (servira pour le plan de salle multi séance)
        var is_block_sessions_ok=true; // Permet de savoir si le blocage des places pour toutes les séances du panier s'est correctement déroulé
        var tab_bloque_hs=[]; // Tableau des séances et/ou superbillet dont on n'a pas réussi à effectuer la déjauges
        var msg_alert_seuil = null;

        if(!(is_empty({"obj":this.data_basket.billetterie})) || !(is_empty({"obj":this.data_basket.confiserie})) || !(is_empty({"obj":this.data_basket.recharge})) || !(is_empty({"obj":this.data_basket.vente_carte})) || !(is_empty({"obj":this.data_basket.vente_carte_fidelite}))){
            // ===== Parcours et vérification du panier =====
            $.each(this.data_basket,function(key,value){
                switch(key){
                    case "billetterie":
                        if(!(is_empty({"obj":value}))){  
                            my_basket.type = "vente_ticket";
                            $.each(value,function(key,value){
                                switch(key){
                                    case "session":
                                        // ===== On boucle sur chaque séance =====
                                        $.each(value,function(key,value){
                                            var nb_tarif_session=0;

                                            var id_session=key;
                                            var id_film=value.id_film;
                                            var list_seats=value.seats;

                                            // ===== On boucle sur chaque tarif =====
                                            $.each(value.tarif,function(key,value){
                                                nb_tarif_session+=value.qte;
                                            });

                                            // ===== Si plan de salle et que les sièges ne sont pas tous choisis =====
                                            if(value.seat_booking && (list_seats.length!=nb_tarif_session)){
                                                // console.log(value)
                                                var data={};

                                                data.id_session=id_session;
                                                data.id_film=id_film;
                                                data.nb=nb_tarif_session;
                                                data.list_seats=list_seats;

                                                let movie_title = value.data_session.data_ms.title;
                                                Swal.fire({
                                                    icon:"info",
                                                    title:"",
                                                    html : 
                                                    '<div class="mb-3">Vous n'+"'"+'avez pas sélectionné tous vos sièges pour la séance suivante</div>'+
                                                    '<div class="mb-3 bold h5">'+movie_title+'</div>'+
                                                    '<div class="mb-3 bold h5">'+moment(value.data_session.date.substr(0,8)).format("DD/MM/YYYY")+' - '+value.data_session.date.substr(8,2)+'h'+value.data_session.date.substr(10,2)+'</div>',
                                                    heightAuto : false,
                                                    scrollbarPadding : false,
                                                    allowOutsideClick : true,
                                                    customClass: {
                                                        icon : "align-items-center"
                                                    }
                                                }); // js/plugins/sweetalert2.js 

                                                is_call_api_ok=false;

                                                return false; // On arrête la boucle sur le panier
                                            }
                                        });
                                        break;
                                    case "superbillet":
                                        $.each(value,function(key,value){
                                            var id_superbillet=key;
                                            var qte=value.qte;
                                            var type_payment=value.type_payment;

                                            var list_seats=value.seats;
                                            var nb_tarif_session=value.nb_session;

                                            // ===== Parcours de toutes les séances du superbillet pour savoir si il y a du plan de salle =====
                                            $.each(value.list_session,function(key,value){
                                                // ===== Si plan de salle et que les sièges ne sont pas tous choisis =====
                                                if(value.seat_booking && (value.seats.length!=qte)){
                                                    var data={};

                                                    data.id_superbillet=id_superbillet;
                                                    data.id_session=value.id_session;
                                                    data.id_film=value.id_movie;
                                                    data.nb=qte;
                                                    data.list_seats=value.seats;

                                                    Swal.fire({
                                                        icon:"info",
                                                        title:"",
                                                        text:"Vous n'avez pas sélectionné tous vos sièges",
                                                        heightAuto : false,
                                                        scrollbarPadding : false,
                                                        allowOutsideClick : true,
                                                        customClass: {
                                                            icon : "align-items-center"
                                                        }
                                                    }); // js/plugins/sweetalert2.js 

                                                    is_call_api_ok=false;

                                                    return false; // On arrête la boucle sur le panier
                                                }
                                            });
                                        });
                                        break;
                                    default:
                                        break;
                                }
                            });                            
                                                    
                            // ===== Appel à la procédure de blocage des places =====
                            if(is_call_api_ok){
                                Overlay.$show({
                                    text : _l("Vérification de la disponibilité, veuillez patientier")
                                });
                                
                                // ===== On va retravailler la variable qui contient le panier afin de supprimer "data_sessions" qui ne sert pas au webservice et qui grossit trop les logs (surtout en plan de salle) =====
                                // ===== Transforme le JSON en chaine avant de le remettre en JSON, afin que le pointeur javascript ne soit plus le même qu'avec la globale "data_basket" =====
                                // ===== Auquel cas, toutes actions auraient entrainées des modifications sur les 2 objets =====
                                var ch_basket=JSON.stringify(my_basket);
                                var basket_soap=JSON.parse(ch_basket);
                                
                                if(!(is_empty({"obj":basket_soap.billetterie}))){
                                    $.each(basket_soap.billetterie,function(key,value){
                                        switch(key){
                                            case "session":
                                                $.each(basket_soap.billetterie.session,function(key,value){
                                                    delete basket_soap.billetterie.session[key].data_session;
                                                });
                                                break;
                                            case "superbillet":
                                                $.each(basket_soap.billetterie.superbillet,function(key,value){
                                                    // delete basket_soap.billetterie.superbillet[key].data_superbillet;
                                                    $.each(basket_soap.billetterie.superbillet[key].data_superbillet.sessions,function(k_session,v_session){
                                                        delete basket_soap.billetterie.superbillet[key].data_superbillet.sessions[k_session].session_data.data_hall_map;
                                                    });
                                                });
                                                break;
                                            default:
                                                break;
                                        };
                                    });
                                }

                                delete basket_soap.data_carte_abo;

                                parameters_api.data=basket_soap;
                            }
                            return false; // on arrête le parcours du panier
                        }
                        break;
                    case "confiserie":
                        if(!(is_empty({"obj":value}))){
                            my_basket.type = "vente_ticket";
                            parameters_api.data=my_basket;
                            Overlay.$show();
                        }
                        break;
                    case "recharge":
                        if(!(is_empty({"obj":value}))){
                            my_basket.type = "recharge_carte_abo";
                            parameters_api.data=my_basket;
                            Overlay.$show();
                        }
                        break;
                    case "vente_carte":
                        if(!(is_empty({"obj":value}))){
                            if(my_basket.scan_value){
                                my_basket.type = "changement_abo";
                            }else{
                                my_basket.type = "vente_carte_abo";
                            }
                            parameters_api.data=my_basket;
                            Overlay.$show();
                        }
                        break;
                    case "vente_carte_fidelite":
                        if(!(is_empty({"obj":value}))){
                            my_basket.type = "vente_carte_fidelite";
                            parameters_api.data=my_basket;
                            Overlay.$show();
                        }
                        break;
                }
            });

            // console.log(parameters_api);
            // return;

            if(is_call_api_ok){
                console.log("Appel ems_bloque_place",parameters_api)
                const res_ems_bloque_place = await gl_api.ems_bloque_place(parameters_api);
                console.log("Result ems_bloque_place",res_ems_bloque_place)

                Overlay.hide();

                if(res_ems_bloque_place.data && res_ems_bloque_place.data.num_cmde && !res_ems_bloque_place.data.code_erreur){
                    my_basket.num_cmde = res_ems_bloque_place.data.num_cmde ? res_ems_bloque_place.data.num_cmde : null;

                    // ===== On parcours le résultat pour indiquer que les places ont été bloqué =====
                    $.each(res_ems_bloque_place.data,function(key,value){
                        switch(key){
                            case "billetterie":
                                $.each(res_ems_bloque_place.data.billetterie,function(key,value){
                                    switch(key){
                                        case "session":
                                            // ===== On boucle sur chaque séance =====
                                            $.each(res_ems_bloque_place.data.billetterie.session,function(key,value){
                                                var id_session=key;
                                                var session_statut=value.statut;
                                                var id_movie=my_basket.billetterie.session[id_session].id_film;

                                                if(value.msg_alerte_seuil){
                                                    msg_alert_seuil = value.msg_alerte_seuil;
                                                }

                                                switch(session_statut){
                                                    case 0:     // ===== Déjauge des places HS =====

                                                        my_basket.billetterie.session[id_session].blocked=false;
                                                        is_block_sessions_ok=false;

                                                        // ===== Si séance en erreur, on va afficher la raison au client =====
                                                        var libelle_erreur="";
                                                        if(res_ems_bloque_place.data.billetterie.session[id_session].libelle_erreur){
                                                            libelle_erreur=res_ems_bloque_place.data.billetterie.session[id_session].libelle_erreur;
                                                        }

                                                        tab_bloque_hs.push({
                                                            "id":id_session,
                                                            "id_movie":id_movie,
                                                            "libelle_erreur":libelle_erreur,
                                                            "type":"session"
                                                        });

                                                        break;
                                                    case 1:     // ===== Déjauge des places OK =====
                                                        my_basket.billetterie.session[id_session].blocked=true;
                                                        break;
                                                    default:

                                                        // ===== Le statut peut être différent, cela correspond à un panier multi séance =====
                                                        // ===== Où une des séance aurait un statut 0, la où les autres ont un statut=2 =====
                                                        // ===== Indique que l'on à juste consulter la jauge de la séance =====
                                                        // ===== Du coup on ne fait rien =====

                                                        break;
                                                }
                                            });
                                            break;
                                        case "superbillet":
                                            // ===== On boucle sur chaque superbillet =====
                                            $.each(res_ems_bloque_place.data.billetterie.superbillet,function(key,value){
                                                var id_superbillet=key;
                                                var superbillet_statut=value.statut;

                                                if(value.msg_alerte_seuil){
                                                    msg_alert_seuil = value.msg_alerte_seuil;
                                                }

                                                switch(superbillet_statut){
                                                    case 0:     // ===== Déjauge des places HS =====

                                                        my_basket.billetterie.superbillet[id_superbillet].blocked=false;
                                                        is_block_sessions_ok=false;

                                                    // ===== Si séance en erreur, on va afficher la raison au client =====
                                                        var libelle_erreur="";
                                                        if(res_ems_bloque_place.data.billetterie.superbillet[id_superbillet].libelle_erreur){
                                                            libelle_erreur=res_ems_bloque_place.data.billetterie.superbillet[id_superbillet].libelle_erreur;
                                                        }

                                                        tab_bloque_hs.push({
                                                            "id":id_superbillet,
                                                            "id_movie":null,
                                                            "libelle_erreur":libelle_erreur,
                                                            "type":"superbillet"
                                                        });
                                                        break;
                                                    case 1:     // ===== Déjauge des places OK =====
                                                        my_basket.billetterie.superbillet[id_superbillet].blocked=true;
                                                        break;
                                                    default:
                                                        // ===== Le statut peut être différent, cela correspond à un panier multi séance =====
                                                        // ===== Où une des séance aurait un statut 0, la où les autres ont un statut=2 =====
                                                        // ===== Indique que l'on à juste consulter la jauge de la séance =====
                                                        // ===== Du coup on ne fait rien =====
                                                        break;
                                                }
                                            });
                                            break;
                                        default:
                                            break;
                                    }
                                });
                                break;
                            case "confiserie":
                                break;
                            default:
                                break;
                        }
                    });
                }else{
                    let error_label;
                    if(res_ems_bloque_place.data.libelle_erreur){
                        error_label = res_ems_bloque_place.data.libelle_erreur;
                    }else if(res_ems_bloque_place.data.billetterie[self.type_session] && res_ems_bloque_place.data.billetterie[self.type_session][self.id_session] && res_ems_bloque_place.data.billetterie[self.type_session][self.id_session].libelle_erreur){
                        error_label = res_ems_bloque_place.data.billetterie[self.type_session][self.id_session].libelle_erreur;
                    }else{
                        error_label = _l("Une erreur est survenue, veuillez réessayer svp");
                    }
                    Swal.fire({
                        icon:"error",
                        title:"Validation du panier",
                        showCloseButton : true,
                        text: _l(error_label),
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : false
                    }).then(function(result){
                        self.raz();
                        window.location.href = "#home";
                    }); 

                    is_block_sessions_ok = false;
                }

                if(is_block_sessions_ok){
                    localStorage.setItem("data_basket", JSON.stringify(my_basket));
                    localStorage.setItem("time_basket", JSON.stringify({"num_cmde":my_basket.num_cmde, "ymdhi":moment().format("YYYYMMDDHHmm")}));
                    window.location.href = "#payment";

                    // ===== On va vérifier si un message d'alerte de seuil est présent =====
                    // ===== Si c'est le cas, le client devra faire une action à l'écran pour continuer ou interrompre son achat =====
                    // if(msg_alert_seuil!=null){
                    //     swal({
                    //         icon:"info",
                    //         title:gl_fic_langue.moovys.confirm_my_order,
                    //         text:msg_alert_seuil,
                    //         buttons: {
                    //             cancel: {
                    //                 text: gl_fic_langue.general.Non,
                    //                 value: false,
                    //                 visible: true,
                    //                 className: "",
                    //                 closeModal: true,
                    //             },
                    //             confirm: {
                    //                 text: gl_fic_langue.general.Oui,
                    //                 value: true,
                    //                 visible: true,
                    //                 className: "",
                    //                 closeModal: true,
                    //             },
                    //         }
                    //     }).then(function(result){
                    //         if(result){
                    //             sell_basket({}); // js/general.js
                    //         }else{
                    //             // ===== RAZ de l'application =====
                    //             maj_inactivite({
                    //                 "mode": "classic"
                    //             }); // js/function.js
                    //         }
                    //     }); // js/plugins/sweetalert2.js
                    // }else{
                    //     sell_basket({}); // js/general.js
                    // }

                    // self.collect();
                }else{
                    // console.log(tab_bloque_hs)
                    // let data_modal = {};
                    // data_modal.tab_bloque_hs = tab_bloque_hs;
                    // data_modal.prog = gDevice.server_prop.prog;
                    // data_modal.super_billets = gDevice.server_prop.super_billets;
                    // // ===== Affichage des raisons du non blocage des places =====
                    // if(tab_bloque_hs.length>0){
                    //     new MSModal({
                    //         button: {
                    //             confirm : {
                    //                 action : null,
                    //                 label : _l("Oui"),
                    //                 show : false
                    //             },
                    //             cancel : {
                    //                 label : _l("Non"),
                    //                 show : false
                    //             },
                    //             ok : {
                    //                 action : () => {
                    //                     self.raz_basket();
                    //                     $('.close_modal').click();
                    //                 },
                    //                 label : _l("Ok"),
                    //                 show : true
                    //             },
                    //         },
                    //         data : data_modal,
                    //         icon : null,
                    //         mode : "bloque_place_hs",
                    //         text : null,
                    //         title : _l("Réservation des séances ci-dessous échouée"),
                    //         timer : null
                    //     })
                    //     .Create();
                    // }
                }
            }  
        }
    }

    check_multi_payment(parameter) {
        // console.log(parameter)
        
        var result=false;
        var id_session=parameter.id_session;
        var type_session=parameter.type_session;
        var type_payment=parameter.type_payment;
        var codebarre=parameter.codebarre;
        let data_basket = this.data_basket;
        
        $.each(data_basket,function(key,value){
            switch(key){
                case "billetterie":
                    $.each(data_basket.billetterie,function(key,value){
                        switch(key){
                            case "session":
                                if(type_session!=key){
                                    result=true;
                                    return false;
                                }
                                // ===== On boucle sur chaque séance =====
                                $.each(data_basket.billetterie.session,function(key,value){
                                    // ===== On boucle sur chaque tarif =====
                                    var id_session=key;
                                    $.each(data_basket.billetterie.session[id_session].tarif,function(key,value){
                                        var id_tarif=key;
                                        
                                        if((type_payment!=value.type_payment) && (type_payment!=8 && value.type_payment!=8)){
                                            result=true;
                                            return false;
                                        }else{
                                            if(type_payment==1 && value.type_payment!=8){ // Carte abo 
                                                $.each(data_basket.billetterie.session[id_session].tarif[id_tarif].codebarre,function(key,value){
                                                    if(codebarre!=value.code){
                                                        result=true;
                                                        return false;
                                                    }
                                                });
                                            }
                                        }
                                    }); 
                                });
                                break;
                            case "superbillet":                       
                                break;
                            default:
                                break;
                        };
                    });
                    break;
                case "confiserie":
                    break;
                case "recharge":
                    break;
                case "vente_carte":
                    break
                default:
                    break;
            };
        });
        
        return result;
    };

    check_multi_session(parameter){
        // console.log(parameter);
        
        var result=false;
        var id_session=parameter.id_session;
        var type_session=parameter.type_session;
        let data_basket = this.data_basket;
        
        $.each(data_basket,function(key,value){
            switch(key){
                case "billetterie":
                    $.each(data_basket.billetterie,function(key,value){
                        switch(key){
                            case "session":
                                if(type_session!=key){
                                    result=true;
                                    return false;
                                }
                                // ===== On boucle sur chaque séance =====
                                $.each(data_basket.billetterie.session,function(key,value){
                                    if(id_session!=key){
                                        result=true;
                                        return false;
                                    }
                                });
                                break;
                            case "superbillet":
                                if(type_session!=key){
                                    result=true;
                                    return false;
                                }
                                $.each(data_basket.billetterie.superbillet,function(key,value){
                                    if(id_session!=key){
                                        result=true;
                                        return false;
                                    }
                                });
                                break;
                            default:
                                break;
                        };
                    });
                    break;
                case "confiserie":
                    break;
                case "recharge":
                    break;
                case "vente_carte":
                    break
                default:
                    break;
            };
        });
        return result;
    };
    
    control_code_cinecheque = (pCode) => {
        let b_ok = true;
        let data_basket = this.data_basket;
        $.each(data_basket,function(key,value){
            switch(key){
                case "billetterie":
                    $.each(data_basket.billetterie,function(key,value){
                        switch(key){
                            case "session":
                                // ===== On boucle sur chaque séance =====
                                $.each(data_basket.billetterie.session,function(key,value){
                                    var id_session=key;
                                    // ===== On boucle sur chaque tarif =====
                                    $.each(data_basket.billetterie.session[id_session].tarif,function(key,value){
                                        var id_tarif=key;
                                        // ===== Si codebarre =====
                                        if(!is_empty({"obj":data_basket.billetterie.session[id_session].tarif[id_tarif].codebarre})){
                                            $.each(data_basket.billetterie.session[id_session].tarif[id_tarif].codebarre,function(key,value){
                                                let codebarre = key;
                                                let prefixe = codebarre.substr(0,2);
                                                switch(prefixe){
                                                    case "CW" : 
                                                        if(pCode.substr(0,2)!="CW"){
                                                            b_ok = false;
                                                        }
                                                        break;
                                                    default : 
                                                        // CS, CT
                                                        if(pCode.substr(0,2)=="CW"){
                                                            b_ok = false;
                                                        }
                                                        break;
                                                }
                                            });
                                        }
                                    });
                                });
                            break;
                        default:
                            break;
                        }
                    });
                    break;
                default:
                    break;
            }
        });
        return b_ok;
    }

    control_unlimited_card = (pCode) => {
        let b_ok = true;
        let txt_error = "";
        let data_basket = this.data_basket;
        $.each(data_basket,function(key,value){
            switch(key){
                case "billetterie":
                    $.each(data_basket.billetterie,function(key,value){
                        switch(key){
                            case "session":
                                // ===== On boucle sur chaque séance =====
                                $.each(data_basket.billetterie.session,function(key,value){
                                    var id_session=key;
                                    // ===== On boucle sur chaque tarif =====
                                    $.each(data_basket.billetterie.session[id_session].tarif,function(key,value){
                                        var id_tarif=key;
                                        let type_payment_tarif = value.type_payment;
                                        // ===== Si codebarre =====
                                        if(!is_empty({"obj":data_basket.billetterie.session[id_session].tarif[id_tarif].codebarre})){
                                            $.each(data_basket.billetterie.session[id_session].tarif[id_tarif].codebarre,function(key,value){
                                                let codebarre = key;
                                                if(codebarre != pCode){
                                                    b_ok = false;
                                                    txt_error = _l("Le paiement avec des contremarques de différents types n'est pas autorisé. Veuillez d'abord solder/annuler votre panier avant de continuer.")
                                                }
                                            });
                                        };
                                    });
                                });
                                break;
                            default:
                                break;
                        }
                    });
                    break;
                default:
                    break;
            }
        });
        let json_return = {};
        json_return.ok = b_ok;
        json_return.txt_error = txt_error;
        return json_return;
    }

    async debloque_place(iParam) {
        // console.log("===== EMSBasket.debloque_place =====", iParam)

        Overlay.$show(); 

        var parameters_api = {};
        parameters_api.data = this.data_basket;
        console.log("Appel ems_debloque_place",parameters_api)
        const res_ems_debloque_place = await gl_api.ems_debloque_place(parameters_api);
        console.log("Result ems_debloque_place",res_ems_debloque_place)
        
        Overlay.hide();
    }

    async end_process() {
        const self = this;
        this.data_basket.nb_place_total = this.nb_place_total;
        this.data_basket.nb_item_total = this.nb_item_total;

        // ===== Définition du mode de paiement de la confiserie : AB ou CB =====
        self.set_mode_payment_confiserie();

        // // ===== Mise à jour du champs qui affiche le nombre de place par tarif pour une séance =====
        await self.update_qty_on_screen();

        if(this.nb_item_total > 0 || this.nb_waiting_seats > 0){
            localStorage.setItem("data_basket", JSON.stringify(this.data_basket));
        }else{
            delete this.data_basket.num_cmde;
            localStorage.removeItem("data_basket");
        }

        console.log("===== Basket.end_process =====", this.data_basket)
    }

    get_data() {
        return this.data_basket;
    }

    async init_process(iParam) {
        console.log("===== Basket.init_process : "+iParam.mode+" =====", iParam)
        const self = this;
        let process_ok = false;
        
        let data_basket = this.data_basket;

        this.data_cinema = iParam.data_cinema;
        this.data_session = Object.assign({},iParam.data_session);
        this.data_movie = Object.assign({},iParam.data_movie);
        this.data_superbillet = Object.assign({},iParam.data_superbillet);
        this.data_item = iParam.data_item;
        this.data_confiserie = iParam.data_confiserie;
        this.is_session = iParam.is_session;
        this.is_superbillet = iParam.is_superbillet;
        this.item_id = this.data_item.id;
        this.data_cm = null;
        this.codebarre = null;
        this.data_basket.num_cine = iParam.data_cinema.num_cine;
        this.qty_to_modify = 1;
        this.multi_payment = this.data_cinema.multi_payment ? this.data_cinema.multi_payment : false;
        this.multi_session = this.data_cinema.multi_session ? this.data_cinema.multi_session : false;
        this.tab_associated_product = [];

        if(iParam.is_session){
            this.id_movie = this.data_movie.id;
        }

        if(this.data_item.is_cm){
            this.data_cm = this.data_item.data_cm.cm;
            this.codebarre = this.data_cm.num_cm;
            if(this.data_cm.promo && this.data_cm.promo.qty){
                this.qty_to_modify = this.data_cm.promo.qty
            }

            if(iParam.mode=="add" && this.data_cm.type==4){ // on va contrôler si des codes cinéchèques sont déjà présents en panier
                if(!self.control_code_cinecheque(this.data_cm.num_cm)){
                    Swal.fire({
                        icon:"info",
                        title:"",
                        text: _l("Saisie invalide ou doublon de code cinéchèque"),
                        showCloseButton : true,
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : true,
                        customClass: {
                            icon : "align-items-center"
                        }
                    });
                    return;
                }
            }

            if(iParam.mode=="add" && this.data_cm.type==16){
                let result_control = self.control_unlimited_card(this.data_cm.num_cm);
                if(!result_control.ok){
                    type_payment_auth=false;
                    Swal.fire({
                        icon:"info",
                        title:"",
                        text: result_control.txt_error,
                        showCloseButton : true,
                        reverseButtons : true,
                        showCancelButton: false,
                        showDenyButton : true,
                        confirmButtonText:_l("Voir mon panier"),
                        denyButtonText : _l("Annuler mon panier"),
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : true,
                        customClass: {
                            icon : "align-items-center"
                        }
                    }).then(function(result){
                        if(result.isConfirmed){
                            window.location.href = "#cart";
                        }else if(result.isDenied){
                            self.raz();
                        }
                    });
                    return;
                }
            }
        }

        // ===== Si une recharge de carte est dans le panier, on n'autorise pas l'ajout de place, il faut d'abord solder le panier =====
        if(iParam.mode=="add" && !is_empty({"obj":data_basket.recharge})){
            Swal.fire({
                icon:"info",
                title:"",
                text: _l("Votre panier contient une recharge de carte abonné, veuillez d'abord solder/annuler ce panier avant de continuer."),
                showCloseButton : true,
                reverseButtons : true,
                showCancelButton: false,
                showDenyButton : true,
                confirmButtonText:_l("Voir mon panier"),
                denyButtonText : _l("Annuler mon panier"),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : true,
                customClass: {
                    icon : "align-items-center"
                }
            }).then(function(result){
                if(result.isConfirmed){
                    window.location.href = "#cart";
                }else if(result.isDenied){
                    self.raz();
                }
            });
            return;
        }

        // ===== Si une vente de carte est dans le panier, on n'autorise pas l'ajout de place, il faut d'abord solder le panier =====
        if(iParam.mode=="add" && !is_empty({"obj":data_basket.vente_carte})){
            Swal.fire({
                icon:"info",
                title:"",
                text: _l("Votre panier contient un achat de carte abonné, veuillez d'abord solder/annuler ce panier avant de continuer."),
                showCloseButton : true,
                reverseButtons : true,
                showCancelButton: false,
                showDenyButton : true,
                confirmButtonText:_l("Voir mon panier"),
                denyButtonText : _l("Annuler mon panier"),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : true,
                customClass: {
                    icon : "align-items-center"
                }
            }).then(function(result){
                if(result.isConfirmed){
                    window.location.href = "#cart";
                }else if(result.isDenied){
                    self.raz();
                }
            });
            return;
        }

        // ===== Si une vente de carte est dans le panier, on n'autorise pas l'ajout de place, il faut d'abord solder le panier =====
        if(iParam.mode=="add" && !is_empty({"obj":data_basket.vente_carte_fidelite})){
            Swal.fire({
                icon:"info",
                title:"",
                text: _l("Votre panier contient un achat de carte fidelité, veuillez d'abord solder/annuler ce panier avant de continuer."),
                showCloseButton : true,
                reverseButtons : true,
                showCancelButton: false,
                showDenyButton : true,
                confirmButtonText:_l("Voir mon panier"),
                denyButtonText : _l("Annuler mon panier"),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : true,
                customClass: {
                    icon : "align-items-center"
                }
            }).then(function(result){
                if(result.isConfirmed){
                    window.location.href = "#cart";
                }else if(result.isDenied){
                    self.raz();
                }
            });
            return;
        }

        if(iParam.item_type == "ticket"){
            this.nb_tarif_en_cours = 0;
            this.nb_lunette_3D_en_cours = 0;
            this.nb_codebarre_in_tab_cm_used = 0;

            if(this.is_session){
                this.type_session = "session";
                this.id_session = this.data_session.ems_id;
                this.is_3d = this.data_session.is_session_3D ? this.data_session.is_session_3D : false;
                this.is_3d_passive = this.data_session.is_session_3D_passive ? this.data_session.is_session_3D_passive : false;
                this.seat_booking = this.data_session.seat_booking ? this.data_session.seat_booking : false;
                this.montant_majo_externe_tot =  this.data_session.majo_externe+this.data_session.majo_laser;
                this.montant_majo_interne = this.data_session.majo_interne;
                this.montant_lunette_externe = this.data_session.montant_lunette_ext;
            }else if(this.is_superbillet){
                this.type_session = "superbillet";
                this.id_session = this.data_superbillet.id;
                this.montant_majo_externe_tot =  this.data_superbillet.majo_externe;
                this.montant_majo_interne = this.data_superbillet.majo_interne;
                this.montant_lunette_externe = this.data_superbillet.montant_lunette_ext;
                this.seat_booking = this.data_superbillet.seat_booking ? this.data_superbillet.seat_booking : false;
                this.is_3d = this.data_superbillet.is_session_3D ? this.data_superbillet.is_session_3D : false;
                this.is_3d_passive = this.data_superbillet.is_session_3D_passive ? this.data_superbillet.is_session_3D_passive : false;
            };

            // ===== Vérification si multi séance non autorisé =====
            if(iParam.mode=="add" && !this.multi_session){
                if(this.check_multi_session({"data_basket":this.data_basket,"id_session":this.id_session,"type_session":this.type_session})){
                    Swal.fire({
                        icon:"info",
                        title:"",
                        text: _l("L'ajout de différentes séances au sein d'un même panier n'est pas autorisé. Veuillez d'abord solder/annuler votre panier avant de continuer."),
                        showCloseButton : true,
                        reverseButtons : true,
                        showCancelButton: false,
                        showDenyButton : true,
                        confirmButtonText:_l("Voir mon panier"),
                        denyButtonText : _l("Annuler mon panier"),
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : true,
                        customClass: {
                            icon : "align-items-center"
                        }
                    }).then(function(result){
                        if(result.isConfirmed){
                            window.location.href = "#cart";
                        }else if(result.isDenied){
                            self.raz();
                        }
                    });
                    return;
                }
            }

            // ===== Vérification si multi paiement non autorisé =====
            if(iParam.mode=="add" && !this.multi_payment){
                if(this.check_multi_payment({"data_basket":this.data_basket,"type_payment":this.data_item.id_type_payment,"id_session":this.id_session,"type_session":this.type_session,"codebarre":this.codebarre})){
                    Swal.fire({
                        icon:"info",
                        title:"",
                        text: _l("Le paiement avec des contremarques de différents types n'est pas autorisé. Veuillez d'abord solder/annuler votre panier avant de continuer."),
                        showCloseButton : true,
                        reverseButtons : true,
                        showCancelButton: false,
                        showDenyButton : true,
                        confirmButtonText:_l("Voir mon panier"),
                        denyButtonText : _l("Annuler mon panier"),
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : true,
                        customClass: {
                            icon : "align-items-center"
                        }
                    }).then(function(result){
                        if(result.isConfirmed){
                            window.location.href = "#cart";
                        }else if(result.isDenied){
                            self.raz();
                        }
                    });
                    return;
                }
            }

            // ===== On récupère le nombre de billet pour le tarif et pour une séance (directement depuis le panier) =====
            if(data_basket.billetterie[this.type_session] && data_basket.billetterie[this.type_session][this.id_session]){
                if(this.type_session=="superbillet"){
                    this.nb_tarif_en_cours=data_basket.billetterie[this.type_session][this.id_session].qte;
                }else if(data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id]){
                    if(this.codebarre){
                        if(data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre]){
                            if(data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].amount==0){
                                this.nb_tarif_exo_en_cours = data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].qte;
                            }else{
                                this.nb_tarif_en_cours=data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].qte;
                            }
                        }
                    }else{
                        this.nb_tarif_en_cours=data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].qte;
                    }
                }

                // ===== On récupère le nombre de lunettes pour la séance =====
                if(this.is_3d){
                    if(data_basket.billetterie[this.type_session][this.id_session].lunette){
                        this.nb_lunette_3D_en_cours=data_basket.billetterie[this.type_session][this.id_session].lunette.qte
                    }
                }
            }

            // ===== Contrôle du nombre de ticket dans le panier =====
            if(iParam.mode == "add"){
                if(this.nb_tarif_en_cours < this.nb_place_max_basket && this.nb_place_total < this.nb_place_max_basket){
                    let type_payment = this.data_item.id_type_payment;
                    if(this.data_item.is_cm && !this.data_cm.promo){
                        type_payment = this.data_item.data_cm.cm.type;
                    }

                    // ===== Selon le mode de règlement, on vérifie si on peut ajouter une place =====
                    switch(type_payment){
                        case 1:         // Carte abonné                        
                            var type_abonnement = this.data_cm.type_abo;
                            switch(type_abonnement){
                                case "A":       // Abonnement "argent"
                                    if(!this.data_cm.illimite_argent){
                                        let solde_insuffisant = false;

                                        // Vérification du solde restant (temps réel)
                                        if(this.data_basket.data_carte_abo){
                                            if((this.data_basket.data_carte_abo.solde_restant.solde_argent - (this.qty_to_modify * (this.data_item.amount+this.data_item.majo_externe))) < 0){
                                                solde_insuffisant = true;
                                            }
                                        }

                                        if(solde_insuffisant || (((this.nb_tarif_en_cours+this.qty_to_modify)*(this.data_item.amount+this.data_item.majo_externe))+(this.nb_lunette_3D_en_cours*this.montant_lunette_externe))>this.data_cm.solde_argent){
                                            // Si son solde est insuffisant pour rajouter la place
                                            // On propose le rechargement (si celui-ci est possible)
                                            // On lui indique aussi que son panier en cours sera RAZ
                                            if(this.data_item.data_cm.recharge && this.data_item.data_cm.recharge.statut == 1){
                                                Swal.fire({
                                                    icon:"info",
                                                    title:"",
                                                    showCancelButton: true,
                                                    reverseButtons : true,
                                                    cancelButtonText:_l("Non"),
                                                    confirmButtonText:_l("Oui"),
                                                    html:
                                                    '<div mt-2>'+_l("Le solde restant sur votre carte ne permet pas d'ajouter cet article")+'</div>'+
                                                    '<div class="my-2">'+_l("Souhaitez-vous recharger votre carte d'abonnement?")+'</div>'+
                                                    '<div class="mt-3 bold">'+_l("Votre panier en cours sera réinitialisé, la sélection de vos articles sera perdue.")+'</div>',
                                                    heightAuto : false,
                                                    scrollbarPadding : false,
                                                    allowOutsideClick : false,
                                                    customClass: {
                                                        icon : "align-items-center"
                                                    }
                                                }).then(function(result){
                                                    if(result.value){
                                                        self.raz()
                                                        localStorage.setItem("reload_data_check_cm",JSON.stringify({"data":self.data_item.data_cm}));
                                                        window.location.href="#subscription?mode=reload&card_number="+self.data_item.data_cm.num_cm;
                                                    }
                                                }); // js/plugins/sweetalert2.js

                                                return;
                                            }

                                            Swal.fire({
                                                icon:"info",
                                                title:"",
                                                text: _l("Le solde de votre carte est insuffisant"),
                                                showCloseButton : true,
                                                heightAuto : false,
                                                scrollbarPadding : false,
                                                allowOutsideClick : true,
                                                customClass: {
                                                    icon : "align-items-center"
                                                }
                                            });                                         
                                        }else{
                                            if(this.data_cm.nb_place_max>0 && this.nb_tarif_en_cours>=this.data_cm.nb_place_max){
                                                Swal.fire({
                                                    icon:"info",
                                                    title:"",
                                                    text: _l("Le nombre maximum de place pour une commande est atteint."),
                                                    showCloseButton : true,
                                                    heightAuto : false,
                                                    scrollbarPadding : false,
                                                    allowOutsideClick : true,
                                                    customClass: {
                                                        icon : "align-items-center"
                                                    }
                                                }); 
                                            }else{
                                                process_ok = true;
                                            }
                                        }
                                    }else{
                                        if(this.data_cm.nb_place_max>0 && this.nb_tarif_en_cours>=this.data_cm.nb_place_max){
                                            Swal.fire({
                                                icon:"info",
                                                title:"",
                                                text: _l("Le nombre maximum de place pour une commande est atteint."),
                                                showCloseButton : true,
                                                heightAuto : false,
                                                scrollbarPadding : false,
                                                allowOutsideClick : true,
                                                customClass: {
                                                    icon : "align-items-center"
                                                }
                                            });
                                        }else{
                                            process_ok = true;
                                        }
                                    }
                                    break;
                                case "M":       // Abonnement "mixte"
                                    if(!this.data_cm.illimite_place){
                                        let type_tarif = this.data_item.type ? this.data_item.type : 5;

                                        if((type_tarif!=5 && this.data_item.amount==0 && (this.data_cm.solde_place_gratuite<(this.nb_tarif_exo_en_cours+this.qty_to_modify))) || (this.data_item.amount>0 && (this.data_cm.solde_place-this.data_cm.solde_place_gratuite)<(this.nb_tarif_en_cours+this.qty_to_modify))){
                                            Swal.fire({
                                                icon:"info",
                                                title:"",
                                                showCancelButton: true,
                                                reverseButtons : true,
                                                cancelButtonText:_l("Non"),
                                                confirmButtonText:_l("Oui"),
                                                html:
                                                    '<div mt-2>'+_l("Le solde restant sur votre carte ne permet pas d'ajouter cet article")+'</div>'+
                                                    '<div class="my-2">'+_l("Souhaitez-vous recharger votre carte d'abonnement?")+'</div>'+
                                                    '<div class="mt-3 bold">'+_l("Votre panier en cours sera réinitialisé, la sélection de vos articles sera perdue.")+'</div>',
                                                heightAuto : false,
                                                scrollbarPadding : false,
                                                allowOutsideClick : false,
                                                customClass: {
                                                    icon : "align-items-center"
                                                }
                                            }).then(function(result){
                                                if(result.value){
                                                    self.raz()
                                                    localStorage.setItem("reload_data_check_cm",JSON.stringify({"data":self.data_item.data_cm}));
                                                    window.location.href="#subscription?mode=reload&card_number="+self.data_item.data_cm.num_cm;
                                                }
                                            }); // js/plugins/sweetalert2.js
                                        }else{
                                            if(this.data_cm.nb_place_max>0 && this.nb_tarif_en_cours>=this.data_cm.nb_place_max){
                                                Swal.fire({
                                                    icon:"info",
                                                    title:"",
                                                    text: _l("Le nombre maximum de place pour une commande est atteint."),
                                                    showCloseButton : true,
                                                    heightAuto : false,
                                                    scrollbarPadding : false,
                                                    allowOutsideClick : true,
                                                    customClass: {
                                                        icon : "align-items-center"
                                                    }
                                                }); 
                                            }else{
                                                process_ok = true;
                                            }
                                        }
                                    }else{
                                        if(this.data_cm.nb_place_max>0 && this.nb_tarif_en_cours>=this.data_cm.nb_place_max){
                                            Swal.fire({
                                                icon:"info",
                                                title:"",
                                                text: _l("Le nombre maximum de place pour une commande est atteint."),
                                                showCloseButton : true,
                                                heightAuto : false,
                                                scrollbarPadding : false,
                                                allowOutsideClick : true,
                                                customClass: {
                                                    icon : "align-items-center"
                                                }
                                            }); 
                                        }else{
                                            process_ok = true;
                                        }
                                    }
                                    break;
                                case "F":       // Abonnement "privilège" (donne accès à un tarif carte bancaire)
                                    // ===== Vérification du nombre max de place (restriction EMS) =====
                                    // ===== Si data_cm.nb_place_max=0 alors pas de restriction =====
                                    if(this.data_cm.nb_place_max>0 && this.nb_tarif_en_cours>=this.data_cm.nb_place_max){
                                        Swal.fire({
                                            icon:"info",
                                            title:"",
                                            text: _l("Le nombre maximum de place pour une commande est atteint."),
                                            showCloseButton : true,
                                            heightAuto : false,
                                            scrollbarPadding : false,
                                            allowOutsideClick : true,
                                            customClass: {
                                                icon : "align-items-center"
                                            }
                                        }); 
                                    }else{
                                        process_ok = true;
                                    }
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 3:        // Carte bancaire
                            process_ok = true;
                            break;
                        case 2:         // Chèque CE
                        case 4:         // Cinéchèque
                        case 5:         // PASS X
                        case 6:         // GRAC
                        case 7:         // OSC
                        case 8:         // Cinéday
                        case 12:       // CIP
                        case 21:        // CinéWest
                        case 23:       // Exoset
                        case 24:       // TicketPartner
                            // if(this.data_cm.solde_place<(this.nb_tarif_en_cours+1)){
                            if((this.data_item.amount==0 && (this.data_cm.solde_place_gratuite<(this.nb_tarif_exo_en_cours+this.qty_to_modify))) || (this.data_item.amount>0 && (this.data_cm.solde_place<(this.nb_tarif_en_cours+this.qty_to_modify)))){
                                Swal.fire({
                                    icon:"info",
                                    title:"",
                                    text: _l("Le solde est insuffisant"),
                                    showCloseButton : true,
                                    heightAuto : false,
                                    scrollbarPadding : false,
                                    allowOutsideClick : true,
                                    customClass: {
                                        icon : "align-items-center"
                                    }
                                });
                            }else{
                                process_ok = true;
                            }
                            break;
                        case 16:       // Carte illimitée
                            if(this.data_cm.solde_place<(this.nb_tarif_en_cours+1)){
                                Swal.fire({
                                icon:"info",
                                title:"",
                                text: _l("Le solde est insuffisant"),
                                showCloseButton : true,
                                heightAuto : false,
                                scrollbarPadding : false,
                                allowOutsideClick : true,
                                customClass: {
                                    icon : "align-items-center"
                                }
                            });
                            }else{
                                process_ok = true;
                            }
                            break;
                        case 18:       // Contremarque Gratuite
                            if(this.data_cm.solde_place<(this.nb_tarif_en_cours+1)){
                                Swal.fire({
                                    icon:"info",
                                    title:"",
                                    text: _l("Le solde est insuffisant"),
                                    showCloseButton : true,
                                    heightAuto : false,
                                    scrollbarPadding : false,
                                    allowOutsideClick : true,
                                    customClass: {
                                        icon : "align-items-center"
                                    }
                                });
                            }else{
                                process_ok = true;
                            }
                            break;
                        // case :          // UGC

                        //     break;
                        default:
                            break;
                    };
                }else{
                    Swal.fire({
                        icon:"info",
                        title:"",
                        text: _l("Le nombre maximum de place pour un panier est atteind."),
                        showCloseButton : true,
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : true,
                        customClass: {
                            icon : "align-items-center"
                        }
                    });
                }

                // ===== On check si le cinéma à une liste de produits associés à ses tarifs =====
                if(this.is_session && gl_ems_config.data_cinema.confiserie.active && (gl_ems_config.data_cinema.confiserie.data.associated_product && gl_ems_config.data_cinema.confiserie.data.associated_product!=null)){
                    $.each(gl_ems_config.data_cinema.confiserie.data.associated_product,function(key,value){
                        let error = false;
                        // ===== Vérification de la pèriode de validité de la règles =====
                        if((value.start_date > moment().format("YYYYMMDD"))){
                            error = true;
                        };
                        if((value.end_date < moment().format("YYYYMMDD"))) {
                            error = true;
                        }
                        // ===== Vérification des jours de la semaine autorisés =====
                        moment.locale("en"); // on passe la local en anglais
                        var day_name_of_week = (moment().format("dddd")).toLowerCase();
                        if(!value.days_in[day_name_of_week]){
                            error = true;
                        };
                        moment.locale(gl_config.site.lang); // on remet la local à son été initial                       

                        // ===== Vérification du film =====
                        if(!value.all_movie && (value.movie_id && (value.movie_id).indexOf(self.id_movie.toString())<0)){
                            error = true;
                        };                        

                        // ===== Vérification du tarif ajouté =====
                        if(!value.all_price && (value.price_id && (value.price_id).indexOf(self.item_id.toString())<0)){
                            error = true;
                        };

                        // ===== On cherche le produits associés dans la liste des produits confiserie =====
                        if(!error){
                            var tab_product_id = value.product_id;
                            for(var i=0;i<tab_product_id.length;i++){
                                // ===== Si type_edition est par transaction, on vérifie si on a déjà un ce/ces produit(s) dans notre panier =====
                                if(value.type_edition=="by_transaction"){
                                    if(self.data_basket.confiserie.product){
                                        $.each(self.data_basket.confiserie.product,function(k,v){
                                            let item_id_basket = k;
                                            if(item_id_basket==tab_product_id[i]){
                                                return false;
                                            };
                                        });
                                    };
                                };

                                $.each(gl_ems_config.data_cinema.confiserie.data.products,function(kp,vp){
                                    if(kp.toString()==tab_product_id[i]){
                                        self.tab_associated_product.push(vp);
                                    };
                                });
                            };
                        }
                    });
                }
            }

            if(iParam.mode == "remove"){
                process_ok = true;
            }
        }

        // ===== AJout d'une paire de lunette 3d au panier =====
        if(iParam.item_type == "lunet_3d"){
            this.nb_lunette_3D_en_cours = 0;

            if(this.is_session){
                this.type_session = "session";
                this.id_session = this.data_session.ems_id;
                this.is_3d = this.data_session.is_session_3D ? this.data_session.is_session_3D : false;
                this.is_3d_passive = this.data_session.is_session_3D_passive ? this.data_session.is_session_3D_passive : false;
                this.seat_booking = this.data_session.seat_booking ? this.data_session.seat_booking : false;
                this.montant_majo_externe_tot =  this.data_session.majo_externe+this.data_session.majo_laser;
                this.montant_majo_interne = this.data_session.majo_interne;
                this.montant_lunette_externe = this.data_session.montant_lunette_ext;
            }else if(this.is_superbillet){
                this.type_session = "superbillet";
                this.id_session = this.data_superbillet.id;
                this.montant_lunette_externe = this.data_superbillet.montant_lunette_ext;
                this.seat_booking = this.data_superbillet.seat_booking ? this.data_superbillet.seat_booking : false;
            };

            // ===== On récupère le nombre de lunettes pour la séance =====
            if(data_basket.billetterie[this.type_session] && data_basket.billetterie[this.type_session][this.id_session]){
                if(data_basket.billetterie[this.type_session][this.id_session].lunette){
                    this.nb_lunette_3D_en_cours=data_basket.billetterie[this.type_session][this.id_session].lunette.qte
                }
            }
            
            if(iParam.mode == "add"){
                if(this.nb_lunette_3D_en_cours < this.nb_place_total){
                    process_ok = true;
                }else{
                    Swal.fire({
                        icon:"info",
                        title:"",
                        showCloseButton : true,
                        text: _l("Vous ne pouvez pas prendre plus de lunettes 3D que de place."),
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : true,
                        customClass: {
                            icon : "align-items-center"
                        }
                    });
                }
            }

            if(iParam.mode == "remove"){
                process_ok = true;
            }
        }

        // ===== Ajout d'un produit confiserie =====
        if(iParam.item_type == "product"){
            if(iParam.mode == "add"){
                process_ok = true;
                this.elem_from = iParam.elem_from;
                if(this.elem_from){
                    gl_app.EMSConfiserie.animation_add_item_to_cart({
                        "elem_from":this.elem_from,
                        "img":this.data_item.img
                    })
                }
            }

            // ===== Si des tarifs sont associés aux produits, on va les retirer du panier =====
            // ===== Cela rappelera la procédure de suppression des articles confiserie associés au tarif =====
            // ===== Donc on break le code si on entre dans la condition =====
            if(iParam.mode == "remove"){
                if(this.data_item.allow_remove_price && data_basket.confiserie[iParam.item_type] && data_basket.confiserie[iParam.item_type][this.item_id].associated_price){
                    var t_pr_temp = data_basket.confiserie[iParam.item_type][this.item_id].associated_price;
                    for(var p=0;p<t_pr_temp.length;p++){
                        var d = Object.assign({},t_pr_temp[p]);

                        self.remove({
                            "data_cinema" : this.data_cinema,
                            "data_item" : d.data_item,
                            "data_movie" : d.data_movie,
                            "data_session" : d.data_session,
                            "data_superbillet": d.data_superbillet,
                            "parent" : null,
                            "is_session" : d.is_session,
                            "is_superbillet" : d.is_superbillet,
                            "item_type" : "ticket"
                        });
                    };

                    process_ok = false;
                }else{
                    process_ok = true;

                    this.nb_item_en_cours = 0;

                    // ===== On récupère le nombre d'item confiserie (directement depuis le panier) =====
                    if(data_basket.confiserie[iParam.item_type] && data_basket.confiserie[iParam.item_type][this.item_id]){
                        this.nb_item_en_cours=parseInt(data_basket.confiserie[iParam.item_type][this.item_id].qte);
                    }
                }
            }
        }

        // ===== Ajout d'un menu confiserie =====
        if(iParam.item_type == "menu"){
            process_ok = true;

            this.nb_item_en_cours = 0;
            this.tab_compo_menu = [];

            if(iParam.mode=="add"){
                this.menu_ref = this.data_item.id;

                if(this.data_item.tab_item_choosen){ // menu avec choix
                    for(var i=0;i<this.data_item.tab_item_choosen.length;i++){
                        var qte_t=1;
                        var tab_ids_t;
                        var find=false;
                        
                        for(var j=0;j<this.tab_compo_menu.length;j++){
                            tab_ids_t=this.tab_compo_menu[j].ids;
                            
                            if(tab_ids_t.indexOf(this.data_item.tab_item_choosen[i])>=0){
                                qte_t=parseInt(this.tab_compo_menu[j].qty);
                                qte_t++;
                                this.tab_compo_menu[j].qty=qte_t;
                                find=true
                            }
                        }
                        
                        if(!find){
                            this.tab_compo_menu.push({"ids":[this.data_item.tab_item_choosen[i]],"qty":qte_t,"label":this.data_confiserie.products[[this.data_item.tab_item_choosen[i]]].label,"price":this.data_confiserie.products[[this.data_item.tab_item_choosen[i]]].price});
                        }
                    }
                }else{                          // menu sans choix
                    this.tab_compo_menu = this.data_item.products;
                    this.elem_from = iParam.elem_from;
                    if(this.elem_from){
                        gl_app.EMSConfiserie.animation_add_item_to_cart({
                            "elem_from":this.elem_from,
                            "img":this.data_item.img
                        })
                    }
                }
            }
            if(iParam.mode=="remove"){
                this.menu_ref = this.data_item.menu_ref;
            }

            // ===== On récupère le nombre d'item confiserie (directement depuis le panier) =====
            if(this.data_basket.confiserie[iParam.item_type] && this.data_basket.confiserie[iParam.item_type][this.item_id]){
                this.nb_item_en_cours=parseInt(this.data_basket.confiserie[iParam.item_type][this.item_id].qte);
            }
        }

        // ===== Ajout d'une recharge =====
        if(iParam.item_type == "reload_subscription"){
            if(iParam.mode=="add" && (!is_empty({"obj":data_basket.billetterie}) || !is_empty({"obj":data_basket.confiserie}))){
                Swal.fire({
                    icon:"info",
                    title:"",
                    text: _l("Votre panier contient de la billetterie et/ou confiserie, veuillez d'abord solder ce panier avant de continuer."),
                    showCloseButton : true,
                    reverseButtons : true,
                    showCancelButton: false,
                    showDenyButton : true,
                    confirmButtonText:_l("Voir mon panier"),
                    denyButtonText : _l("Annuler mon panier"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : true,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then(function(result){
                    if(result.isConfirmed){
                        window.location.href = "#cart";
                    }else if(result.isDenied){
                        self.raz();
                    }
                });
                return false;
            }

            process_ok = true;
        }

        // ===== Ajout d'une vente de carte abo =====
        if(iParam.item_type == "sell_subscription"){
            if(iParam.mode=="add" && (!is_empty({"obj":data_basket.billetterie}) || !is_empty({"obj":data_basket.confiserie}))){
                Swal.fire({
                    icon:"info",
                    title:"",
                    text: _l("Votre panier contient de la billetterie et/ou confiserie, veuillez d'abord solder ce panier avant de continuer."),
                    showCloseButton : true,
                    reverseButtons : true,
                    showCancelButton: false,
                    showDenyButton : true,
                    confirmButtonText:_l("Voir mon panier"),
                    denyButtonText : _l("Annuler mon panier"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : true,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then(function(result){
                    if(result.isConfirmed){
                        window.location.href = "#cart";
                    }else if(result.isDenied){
                        self.raz();
                    }
                });
                return false;
            }

            process_ok = true;
        }
        
        // ===== Ajout d'une vente de carte abo =====
        if(iParam.item_type == "sell_fidelity"){
            if(iParam.mode=="add" && (!is_empty({"obj":data_basket.billetterie}) || !is_empty({"obj":data_basket.confiserie}))){
                Swal.fire({
                    icon:"info",
                    title:"",
                    text: _l("Votre panier contient de la billetterie et/ou confiserie, veuillez d'abord solder ce panier avant de continuer."),
                    showCloseButton : true,
                    reverseButtons : true,
                    showCancelButton: false,
                    showDenyButton : true,
                    confirmButtonText:_l("Voir mon panier"),
                    denyButtonText : _l("Annuler mon panier"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : true,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then(function(result){
                    if(result.isConfirmed){
                        window.location.href = "#cart";
                    }else if(result.isDenied){
                        self.raz();
                    }
                });
                return false;
            }

            process_ok = true;
        }

        // console.log("===== Basket.init_process -> result : "+process_ok+" =====")

        return process_ok;
    }

    async maj_virtual_solde_abo(iParam) {
        // console.log("===== maj_virtual_solde_abo =====", iParam)
        let amount = iParam.amount;
        let basket_data_carte_abo = iParam.basket_data_carte_abo;
        let data_cm = iParam.data_cm;
        let mode = iParam.mode;
        let price = iParam.price;
        let qty_to_modify = iParam.qty_to_modify;
        let type = iParam.type; // ticket, lunet_3d, confiserie

        let type_abonnement=data_cm.type_abo;

        let reste_solde_place = 0;
        let reste_solde_place_gratuite = 0;
        let reste_solde_argent = 0;

        if(!basket_data_carte_abo){
            basket_data_carte_abo = {};
            basket_data_carte_abo.info = {};
            basket_data_carte_abo.solde_restant = {};
            basket_data_carte_abo.info = data_cm;

            reste_solde_place = data_cm.solde_place;
            reste_solde_place_gratuite = data_cm.solde_place_gratuite;
            reste_solde_argent = data_cm.solde_argent;
        }else{
            reste_solde_place = basket_data_carte_abo.solde_restant.solde_place;
            reste_solde_place_gratuite = basket_data_carte_abo.solde_restant.solde_place_gratuite;
            reste_solde_argent = basket_data_carte_abo.solde_restant.solde_argent;
        }

        switch(mode){
            case "minus" : // débit du solde de la carte
                switch(type_abonnement){
                    case "A":       // Abonnement "argent"
                        if(!data_cm.illimite_argent){
                            reste_solde_argent = parseFloat(reste_solde_argent)-amount;
                        }
                        break;
                    case "M":       // Abonnement "mixte"
                        if(!data_cm.illimite_place){
                            if(price==0){
                                if(type=="ticket"){
                                    reste_solde_place_gratuite = parseInt(reste_solde_place_gratuite)-(qty_to_modify);
                                }
                            }else{
                                if(type=="ticket"){
                                    reste_solde_place = parseInt(reste_solde_place)-(qty_to_modify); 
                                }
                                if(data_cm.solde_argent > 0){
                                    reste_solde_argent = parseFloat(reste_solde_argent)-amount;
                                }else{
                                    reste_solde_argent = null;
                                }
                            }
                        }
                        break;
                    default:
                        break;
                }
                break;
            case "plus" : // crédit du solde de la carte
                switch(type_abonnement){
                    case "A":       // Abonnement "argent"
                        if(!data_cm.illimite_argent){
                            reste_solde_argent = parseFloat(reste_solde_argent)+amount;
                        }
                        break;
                    case "M":       // Abonnement "mixte"
                        if(!data_cm.illimite_place){
                            if(price==0){
                                if(type=="ticket"){
                                    reste_solde_place_gratuite = parseInt(reste_solde_place_gratuite)+(qty_to_modify);
                                }
                            }else{
                                if(type=="ticket"){
                                    reste_solde_place = parseInt(reste_solde_place)+(qty_to_modify); 
                                }
                                if(data_cm.solde_argent > 0){
                                    reste_solde_argent = parseFloat(reste_solde_argent)+amount;

                                    if(reste_solde_argent > data_cm.solde_argent){
                                        reste_solde_argent = data_cm.solde_argent;
                                    }
                                }
                            }
                        }
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }

        basket_data_carte_abo.solde_restant.solde_place = reste_solde_place;
        basket_data_carte_abo.solde_restant.solde_place_gratuite = reste_solde_place_gratuite;
        basket_data_carte_abo.solde_restant.solde_argent = reste_solde_argent;

        return basket_data_carte_abo;
    }

    async raz() {
        // console.log("===== EMSBasket.raz =====", this.data_basket)
        const self = this;
        const data_basket = this.data_basket;

        $.each(data_basket,function(key,value){
            switch(key){
                case "billetterie":
                    $.each(data_basket.billetterie,function(key,value){
                        switch(key){
                            case "session":
                                // ===== On boucle sur chaque séance =====
                                $.each(data_basket.billetterie.session,function(key,value){
                                    var data={};
                                    var id_session=key;

                                    // ===== Si les places n'ont pas été bloquées, on les supprime du panier avant d'appeler le webservice pour rejauger les places =====
                                    if(!(value.blocked)){
                                        delete data_basket.billetterie.session[id_session];
                                    }
                                });

                                // ===== Si il n'y a plus de séances =====
                                if((is_empty({"obj":data_basket.billetterie.session}))){
                                    delete data_basket.billetterie.session;
                                }
                                break;
                            case "superbillet":
                                $.each(data_basket.billetterie.superbillet,function(key,value){
                                    var id_superbillet=key;

                                    // ===== Si les places n'ont pas été bloquées, on les supprime du panier avant d'appeler le webservice pour rejauger les places =====
                                    if(!(value.blocked)){

                                        $.each(data_basket.billetterie.superbillet[id_superbillet].list_session,function(key,value){
                                            delete data_basket.billetterie.superbillet[id_superbillet].list_session[key];
                                        });

                                        if((is_empty({"obj":data_basket.billetterie.superbillet[id_superbillet].list_session}))){
                                            delete data_basket.billetterie.superbillet[id_superbillet];
                                        }
                                    }
                                });

                                // ===== Si il n'y a plus de superbillet =====
                                if((is_empty({"obj":data_basket.billetterie.superbillet}))){
                                    delete data_basket.billetterie.superbillet;
                                }
                                break;
                            default:
                                break;
                        }
                    });
                    break;
                default:
                    break;
            }
        });

        // ===== Si il reste des séances dans le panier, on appel le webservice pour rejauger les places =====
        if(!(is_empty({"obj":data_basket.billetterie}))){
            var basket_soap = Object.assign({}, data_basket);
            if(!(is_empty({"obj":basket_soap.billetterie}))){
                $.each(basket_soap.billetterie,function(key,value){
                    switch(key){
                        case "session":
                            $.each(basket_soap.billetterie.session,function(key,value){
                                delete basket_soap.billetterie.session[key].data_session;
                            });
                            break;
                        case "superbillet":
                            $.each(basket_soap.billetterie.superbillet,function(key,value){
                                delete basket_soap.billetterie.superbillet[key].data_session;
                            });
                            break;
                        default:
                            break;
                    };
                });
            }
            self.debloque_place(basket_soap);
        }

        // ===== RAZ de la variable du panier =====
        this.nb_place_total = 0;
        this.nb_item_total = 0;
        this.data_basket = {
            "billetterie": {},
            "confiserie": {},
            "recharge": {},
            "vente_carte": {},
            "vente_carte_fidelite": {},
            "nb_place_total": 0,
            "nb_item_total": 0,
            "total" : 0,
            "mode_payment" : gl_ems_config.data_cinema.mode_PSP
        };

        localStorage.removeItem("show_warning_time_basket")
        localStorage.removeItem("time_basket");
        // localStorage.removeItem("email_cm");
        localStorage.removeItem("id_confiserie_unit");
        this.id_confiserie_unit = {};

        this.end_process();
    }

    reinit() {
        // ===== RAZ de la variable du panier =====
        this.nb_place_total = 0;
        this.nb_item_total = 0;
        this.data_basket = {
            "billetterie": {},
            "confiserie": {},
            "recharge": {},
            "vente_carte": {},
            "vente_carte_fidelite": {},
            "nb_place_total": 0,
            "nb_item_total": 0,
            "total" : 0,
            "mode_payment" : gl_ems_config.data_cinema.mode_PSP
        };

        localStorage.removeItem("data_basket")
        localStorage.removeItem("show_warning_time_basket")
        localStorage.removeItem("time_basket");
    }

    async remove(iParam) {
        // console.log("===== Basket.remove =====", iParam)
        iParam.mode = "remove";
        const self = this;
        const process_ok = await self.init_process(iParam);

        if(process_ok){
            switch(iParam.item_type){
                case "ticket":
                    self.remove_ticket();
                    break;
                case "lunet_3d":
                    self.remove_lunet_3d();
                    break;
                case "menu":
                case "product":
                    self.remove_confiserie();
                    break;
                case "reload_subscription":
                    self.remove_reload_subscription();
                    break;
                case "sell_subscription":
                    self.remove_sell_subscription();
                    break;
                default:
                    break;
            }
        }
    }

    async remove_confiserie() {
        // console.log(this.data_item)
        const self = this;
        if(this.nb_item_en_cours>0){
            
            this.nb_item_en_cours--;
            this.nb_item_total--;

            this.data_basket.confiserie.mode_payment = "CB";

            if(this.data_basket.data_carte_abo){
                this.data_basket.data_carte_abo = await self.maj_virtual_solde_abo({
                    "amount" : this.data_item.price,
                    "basket_data_carte_abo" : this.data_basket.data_carte_abo,
                    "data_cm" : this.data_basket.data_carte_abo.info,
                    "mode" : "plus",
                    "price" : this.data_item.price,
                    "qty_to_modify" : 1,
                    "type" : "confiserie"
                }); // js/fonction.js

                // let reste_solde_argent = this.data_basket.data_carte_abo.solde_restant.solde_argent;
                // if(reste_solde_argent && reste_solde_argent>=0){
                //     this.data_basket.confiserie.mode_payment = "AB";
                // }
            }

            var new_qte=parseInt(this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].qte)-1;
            this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].qte=new_qte;

            // ===== Si référence menu, on supprime ce menu =====
            if(this.data_item.item_type=="menu"){
                if(this.menu_ref){
                    delete this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].ref_list[this.menu_ref];
                }else{
                    delete this.data_basket.confiserie[this.data_item.item_type][this.data_item.id].ref_list[this.data_item.id+"-"+new_qte];
                }
            }

            if(new_qte==0){
                await self.update_qty_on_screen();
                delete this.data_basket.confiserie[this.data_item.item_type][this.data_item.id];
            }

            // ===== Si plus de menu ou de produit , on supprime l'objet du panier =====
            if(is_empty({"obj":this.data_basket.confiserie[this.data_item.item_type]})){
                await self.update_qty_on_screen();
                delete this.data_basket.confiserie[this.data_item.item_type];
            } // js/function.js

            // ===== Si plus de menu et plus de produit =====
            if(is_empty({"obj":this.data_basket.confiserie.product}) && is_empty({"obj":this.data_basket.confiserie.menu})){
                await self.update_qty_on_screen();
                delete this.data_basket.confiserie.mode_payment;
            }

            // ===== Tableau unitaire des articles confiserie =====
            // ===== Sert pour le calcul auto des menus =====
            if(this.data_item.item_type == "product"){
                if(this.id_confiserie_unit[this.data_item.id]){
                    this.id_confiserie_unit[this.data_item.id].qty--;
                    if(this.id_confiserie_unit[this.data_item.id].qty==0){
                        delete this.id_confiserie_unit[this.data_item.id];
                    }
                }
            }else if(this.data_item.item_type == "menu"){
                this.data_item.compo_menu.forEach(product => {
                    for(var q=0;q<product.qty;q++){
                        if(this.id_confiserie_unit[product.ids[0]]){
                            this.id_confiserie_unit[product.ids[0]].qty--;
                            if(this.id_confiserie_unit[product.ids[0]].qty==0){
                                delete this.id_confiserie_unit[product.ids[0]];
                            }
                        }
                    }
                });
            }

            localStorage.setItem("id_confiserie_unit",JSON.stringify(this.id_confiserie_unit));
            self.end_process();
        }
    }

    async remove_lunet_3d() {
        // i_log("===== Basket.remove_lunet_3d =====")
        const self = this;

        if(this.nb_lunette_3D_en_cours>0){
            // ===== Si paiement via carte abo, on va rajouter les infos de la carte à la racine du panier =====
            // ===== Ceci afin de les retrouver plus facilement dans le cas d'un achat de confiserie avec solde argent =====
            if(this.data_basket.data_carte_abo){
                var type_abonnement = this.data_basket.data_carte_abo.info.type_abo;
                
                switch(type_abonnement){
                    case "A":       // Abonnement "argent"
                        var price_abo = this.data_basket.data_carte_abo.prix_place;

                        this.data_basket.data_carte_abo = await self.maj_virtual_solde_abo({
                            "amount" : this.montant_lunette_externe,
                            "basket_data_carte_abo" : this.data_basket.data_carte_abo,
                            "data_cm" : this.data_basket.data_carte_abo.info,
                            "mode" : "plus",
                            "price" : price_abo,
                            "qty_to_modify" : this.qty_to_modify,
                            "type" : "ticket"
                        }); // js/fonction.js
                        break;
                    case "M":       // Abonnement "mixte"
                        
                        break;
                    default:
                        break;
                }
            }

            this.nb_item_total -= this.qty_to_modify;
        }
        this.nb_lunette_3D_en_cours -= this.qty_to_modify;

        if(this.nb_lunette_3D_en_cours<0){
            this.nb_lunette_3D_en_cours = 0;
        }

        if(this.data_basket.billetterie[this.type_session] && this.data_basket.billetterie[this.type_session][this.id_session] && this.data_basket.billetterie[this.type_session][this.id_session].lunette){
            this.data_basket.billetterie[this.type_session][this.id_session].lunette.qte = this.nb_lunette_3D_en_cours;
        }

        self.end_process();
    }

    remove_reload_subscription() {
        // console.log("===== Basket.remove_reload_subscription =====")
        const self = this;

        this.data_basket.recharge = {};

        self.end_process();
    }

    remove_sell_subscription() {
        // console.log("===== Basket.remove_sell_subscription =====")
        const self = this;

        this.data_basket.vente_carte = {};

        self.end_process();
    }

    async remove_ticket() {
        // console.log("===== Basket.remove_ticket =====", this.data_item)
        const self = this;
        let new_qte = 0;
        let item_amount = this.data_item.price ? this.data_item.price : this.data_item.amount ? this.data_item.amount : 0;
        let item_majo_externe = this.data_item.majo_externe;

        // ===== On supprime le codebarre du tableau des contremarques utilisées =====
        if(this.codebarre){
            var i_cm=this.list_cm_used.indexOf(this.codebarre);

            if(i_cm>=0){
                this.list_cm_used.splice(i_cm,1);
            }
            
            // if(this.nb_tarif_en_cours<=0 && this.data_item.id_type_payment!=3){
            if((this.nb_tarif_en_cours<=0 && item_amount>0) || (item_amount == 0 && this.nb_tarif_exo_en_cours<=0)){
                // ===== Si plus de contremarque, on remet la liste des tarifs CB =====
                if(this.list_cm_used.length==0){
                    // gl_id_type_paiement=0;
                    // gl_cm_in_basket=false;
                    $(".box_price_list_cb").show();
                    // $("#box_separator_payment").removeClass("hide");
                    // $("#box_code_promo").removeClass("hide");
                }

                $(".line_cm_"+this.codebarre).remove();
            }
        }

        
        if(this.nb_tarif_en_cours>0 || (item_amount == 0 && this.nb_tarif_exo_en_cours)){
            // ===== Si paiement via carte abo, on va rajouter les infos de la carte à la racine du panier =====
            // ===== Ceci afin de les retrouver plus facilement dans le cas d'un achat de confiserie avec solde argent =====
            if(this.data_basket.data_carte_abo){
                var type_abonnement = this.data_basket.data_carte_abo.info.type_abo;

                let amount = 0.00;
                
                switch(type_abonnement){
                    case "A":       // Abonnement "argent"
                        if(!this.data_cm.illimite_argent){
                            amount = (((this.qty_to_modify)*(item_amount+item_majo_externe))+(this.nb_lunette_3D_en_cours*this.montant_lunette_externe));
                        }
                        break;
                    case "M":       // Abonnement "mixte"
                        if(!this.data_cm.illimite_place){
                            if(this.data_cm.solde_argent>0){
                                amount = (((this.qty_to_modify)*(item_majo_externe))+(this.nb_lunette_3D_en_cours*this.montant_lunette_externe));
                            }
                        }
                        break;
                    default:
                        break;
                }

                this.data_basket.data_carte_abo = await self.maj_virtual_solde_abo({
                    "amount" : amount,
                    "basket_data_carte_abo" : this.data_basket.data_carte_abo,
                    "data_cm" : this.data_cm,
                    "mode" : "plus",
                    "price" : item_amount,
                    "qty_to_modify" : this.qty_to_modify,
                    "type" : "ticket"
                }); // js/fonction.js
            }

            // ===== Si séance 3D =====
            if(this.is_3d){
                // ===== Si 3D active ou que le nb de billet est égale au nb de lunette , on retire automatiquement une paire de lunettes =====
                if(!this.is_3d_passive || this.nb_lunette_3D_en_cours == this.nb_tarif_en_cours){
                    self.remove_lunet_3d();
                }
            }

            this.nb_tarif_en_cours -= this.qty_to_modify;
            this.nb_place_total -= this.qty_to_modify;
            this.nb_item_total -= this.qty_to_modify;

            if(item_amount == 0){
                this.nb_tarif_exo_en_cours -= this.qty_to_modify;
            }

            // ===== Si plan de salle =====
            if(this.data_basket.billetterie[this.type_session][this.id_session] && this.data_basket.billetterie[this.type_session][this.id_session].seat_booking){
                // ===== On supprime le siège de la séance concernée et du tableau des tarifs pour la séance concernée =====
                switch(this.type_session){
                    case "session":
                        $.each(this.data_basket.billetterie[this.type_session][this.id_session].tarif,function(key,value){
                            var id_price=key;
                            var seats_by_price=value.seats;

                            if(self.item_id==id_price){
                                for(var i=0;i<seats_by_price.length;i++){
                                    let seat_info = {};
                                    seat_info.element = $(".img_seat."+seats_by_price[i]);
                                    seat_info.type = $(".img_seat."+seats_by_price[i]).data("type");
                                    seat_info.seat_name = seats_by_price[i];
                                    seat_info.seat_section = undefined;
                                    seat_info.is_session = true;
                                    seat_info.is_superbillet = false;
                                    seat_info.data_session = self.data_session;
                                    seat_info.data_superbillet = self.data_superbillet;

                                    self.unselect_seat({
                                        "seat_info":seat_info
                                    });
                                    break;
                                }
                                return false; 
                            }
                        });  
                        break;
                    case "superbillet":
                        $.each(this.data_basket.billetterie[this.type_session][this.id_session].list_session,function(key,value){
                            var id_session_temp=parseInt(key);
                            var seats_by_price=value.seats;

                            // ===== Si on a encore des sièges pour la séance en cours, on supprime cela d'abord =====
                            // ===== On est dans le cas où l'internaute à fait moins et non pas cliqué sur un siège pour le désélectionné =====
                            if(seats_by_price.length>0){
                                for(var i=0;i<seats_by_price.length;i++){
                                    let seat_info = {};
                                    seat_info.element = $("#seat_booking_session_id_"+id_session_temp+" .img_seat."+seats_by_price[i]);
                                    seat_info.type = $("#seat_booking_session_id_"+id_session_temp+" .img_seat."+seats_by_price[i]).data("type");
                                    seat_info.seat_name = seats_by_price[i];
                                    seat_info.seat_section = undefined;
                                    seat_info.is_session = false;
                                    seat_info.is_superbillet = true;
                                    seat_info.data_session = self.data_session;
                                    seat_info.data_superbillet = self.data_superbillet;

                                    self.unselect_seat({
                                        "seat_info":seat_info
                                    });
                                    break;
                                }
                            }
                        }); 
                        break;
                    default:
                        break;
                }
            }

            var t_pr_temp = [];
            switch(this.type_session){
                case "session":
                    // ===== Si des produits sont associés au tarif, on va les retirer du panier =====
                    if(this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].associated_product){
                        t_pr_temp = this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].associated_product;
                    };
                    
                    new_qte=parseInt(this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].qte) - this.qty_to_modify;
                    this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].qte=new_qte;

                    // ===== Nouvelle quantité =====
                    if(this.codebarre){
                        if(this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre]){
                            let new_qte_codebarre=parseInt(this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].qte) - this.qty_to_modify;
                            this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre].qte=new_qte_codebarre;

                            if(new_qte_codebarre==0){
                                await self.update_qty_on_screen();
                                delete this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id].codebarre[this.codebarre];
                            }
                        }
                    }

                    if(new_qte==0){
                        await self.update_qty_on_screen();
                        delete this.data_basket.billetterie[this.type_session][this.id_session].tarif[this.item_id];
                    }

                    // ===== Si plus de tarif, on supprime la séance du panier =====
                    if(is_empty({"obj":this.data_basket.billetterie[this.type_session][this.id_session].tarif})){
                        delete this.data_basket.billetterie[this.type_session][this.id_session];

                        if(this.data_item.id_type_payment==1){
                            delete this.data_basket.data_carte_abo;

                            // Si de la confiserie était à payer avec le solde argent de la carte, on supprime la confiserie du panier
                            if(!is_empty({"obj":this.data_basket.confiserie}) && this.data_basket.confiserie.mode_payment == "AB"){
                                delete this.data_basket.confiserie.product;
                                delete this.data_basket.confiserie.menu;
                                delete this.data_basket.confiserie.mode_payment;
                                this.nb_item_total = 0;
                            }
                        }
                    }
                    break;
                case "superbillet":
                    new_qte=parseInt(this.data_basket.billetterie[this.type_session][this.id_session].qte)-1;
                    
                    // ===== Si plus de quantité, on supprime le superbillet du panier =====
                    if(new_qte==0){
                        await self.update_qty_on_screen();
                        delete this.data_basket.billetterie[this.type_session][this.id_session];
                    }else{
                        this.data_basket.billetterie[this.type_session][this.id_session].qte=new_qte;
                    }
                    break;
                default:
                    break;
            };

            // ===== Si plus de séance ou de superbillet , on supprime l'objet du panier =====
            if(is_empty({"obj":this.data_basket.billetterie[this.type_session]})){
                await self.update_qty_on_screen();
                delete this.data_basket.billetterie[this.type_session];
            }

            self.end_process();

            // ===== Produits associés au tarif =====
            for(var p=0;p<t_pr_temp.length;p++){
                var d = Object.assign({},t_pr_temp[p]);
                d.item_type = "product";
                d.allow_remove_price = false;
                self.remove({
                    "data_item" : d,
                    "data_cinema" : this.data_cinema,
                    "data_movie" : this.data_movie,
                    "data_session" : this.data_session,
                    "data_superbillet": this.data_superbillet,
                    "parent" : null,
                    "is_session" : this.is_session,
                    "is_superbillet" : this.is_superbillet,
                    "item_type" : d.item_type
                });
            };
        }
    }

    set_email_to_basket = (iEmail) => {
        this.data_basket.email = iEmail;
        return true;
    }

    set_mode_payment_confiserie = () => {
        // console.log("set_mode_payment_confiserie", data_basket)
        let solde_argent_carte_abo = 0;
        let total_confiserie = 0;

        if(!is_empty({"obj":this.data_basket.confiserie})){
            if(!this.data_basket.confiserie.mode_payment){
                this.data_basket.confiserie.mode_payment = "CB";
            }

            // on cherche a récupérer le solde argent de la carte abo dans le panier
            if(!is_empty({"obj":this.data_basket.billetterie})){
                $.each(this.data_basket.billetterie,function(key,value){
                    if(key == "session"){
                        $.each(value,(key, value) => {
                            $.each(value,(key, value) => {
                                if(key == "tarif"){
                                    $.each(value,(key, value) => {
                                        if(!is_empty({"obj":value.codebarre})){
                                            if(value.type_payment == 1){
                                                $.each(value.codebarre,(key, value) => {
                                                    solde_argent_carte_abo = value.data_cm.cm.solde_argent
                                                })
                                            }
                                        }
                                    })
                                }
                            })
                            
                        })
                    }
                });
            }

            // si la carte à un solde argent supèrieur à 0, on cherche le montant total de la confiserie
            if(solde_argent_carte_abo>0){
                $.each(this.data_basket.confiserie,function(key,value){
                    switch(key){
                        case "menu":
                            $.each(value,(key, value) => {
                                total_confiserie += parseFloat(value.price * value.qte)
                            });
                            break;
                        case "product":
                            $.each(value,(key, value) => {
                                total_confiserie += parseFloat(value.price * value.qte)
                            });
                            break;
                        default:
                            break;
                    }
                });
                if(solde_argent_carte_abo >= total_confiserie){
                    this.data_basket.confiserie.mode_payment = "AB";
                }
            }
        }
    }

    set_data_vad_to_basket = (iData) => {
        this.data_basket.vad = iData;
        return true;
    }

    set_data_to_basket_vente_carte = (iData) => {
        // console.log(iData)
        if(!is_empty({"obj":this.data_basket.vente_carte})){
            this.data_basket.vente_carte.user = iData.user;
            this.data_basket.vente_carte.fidelity = iData.fidelity;
        }       
        // console.log(this.data_basket)
        return true;
    }

    set_data_to_basket_vente_carte_fidelite = (iData) => {
        // console.log(iData)
        if(!is_empty({"obj":this.data_basket.vente_carte_fidelite})){
            this.data_basket.vente_carte_fidelite.user = iData.user;
            this.data_basket.vente_carte_fidelite.code_parrainage = iData.code_parrainage;
        }       
        // console.log(this.data_basket)
        return true;
    }

    set_nb_place_max_basket = (iNb) => {
        this.nb_place_max_basket = iNb;
    }

    async update_qty_on_screen() {
        const self = this;

        this.data_basket.total = 0;

        let total_basket= 0;
        let nb_item_total = 0;
        let total_frais_basket = 0;
        let total_majo_cm = 0.00;
        let data_cm = {};

        $(".nb_item").each(function(){
            $(this)[0].textContent = 0;
            $(this).removeClass("active");
        })

        $.each(this.data_basket.billetterie.session,function(key_session,value_session){
            let id_session = key_session;
            $.each(value_session.tarif,function(key_tarif,value_tarif){
                let price_id = key_tarif;
                let data_frais_tarif = gl_ems_config.data_cinema.frais_tarif.filter(frais => frais.id == price_id)[0];
                if(!is_empty({"obj":value_tarif.codebarre})){
                    $.each(value_tarif.codebarre,function(key_codebarre,value_codebarre){
                        let barcode = key_codebarre;
                        barcode = barcode.replaceAll("-","_");
                        barcode = barcode.replaceAll("@","_");
                        data_cm = value_codebarre.data_cm.cm;
                        $(".nb_price_id_"+price_id+"_"+id_session+"_"+barcode).each(function(){
                            $(this)[0].textContent = value_codebarre.qte;
                            if(value_tarif.qte==0){
                                $(this).removeClass("active");
                            }else{
                                $(this).addClass("active");
                            }
                        });
                    });

                    let cb_cm = 0.00;
                    if(data_cm.type == 1 && data_cm.type_abo == "A"){
                        total_basket += 0;
                    }else if ((data_cm.type == 1 && data_cm.type_abo == "F") || data_cm.type == 14){
                        total_basket += value_tarif.qte * (value_tarif.amount + value_tarif.majo_externe);
                        cb_cm = value_tarif.qte * (value_tarif.amount + value_tarif.majo_externe);
                    }else{
                        total_basket += value_tarif.qte * (value_tarif.majo_interne + value_tarif.majo_externe);
                        cb_cm = value_tarif.qte * (value_tarif.majo_interne + value_tarif.majo_externe);
                    }

                    total_majo_cm += cb_cm;

                    nb_item_total += value_tarif.qte;

                    // ===== Calcul des frais VAD =====
                    var montant_frais = 0.00;
                    montant_frais = gl_app.calc_fees_amount({
                        "frais_inclus" : data_frais_tarif.inclus,
                        "mode_frais" : data_frais_tarif.mode,
                        "total_frais" : data_frais_tarif.value,
                        // "montant" : gl_app.arrondi({"montant" : value_tarif.qte * (value_tarif.majo_interne + value_tarif.majo_externe)}),
                        "montant" : gl_app.arrondi({"montant" : cb_cm}),
                        "qte" : value_tarif.qte
                    });

                    if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                        total_frais_basket += montant_frais;
                    }else{
                        total_basket += montant_frais
                    }
                }else{
                    if($(".nb_price_id_"+price_id+"_"+id_session).length>0){
                        $(".nb_price_id_"+price_id+"_"+id_session).each(function(){
                            $(this)[0].textContent = value_tarif.qte; 
                            if(value_tarif.qte==0){
                                $(this).removeClass("active");
                            }else{
                                $(this).addClass("active");
                            }
                        });
                    }
                    total_basket += value_tarif.qte * (value_tarif.amount + value_tarif.majo_externe);
                    nb_item_total += value_tarif.qte;

                    // ===== Calcul des frais VAD =====
                    var montant_frais = 0.00;
                    montant_frais = gl_app.calc_fees_amount({
                        "frais_inclus" : data_frais_tarif.inclus,
                        "mode_frais" : data_frais_tarif.mode,
                        "total_frais" : data_frais_tarif.value,
                        "montant" : gl_app.arrondi({"montant" : value_tarif.qte * (value_tarif.amount + value_tarif.majo_externe)}),
                        "qte" : value_tarif.qte
                    });

                    if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                        total_frais_basket += montant_frais;
                    }else{
                        total_basket += montant_frais
                    }
                }
            });

            if(value_session.lunette && $(".nb_lunet_3d_"+id_session).length>0){
                let calc_frais = true;  
                if(data_cm.type == 1 && data_cm.type_abo == "A"){
                    total_basket += 0;
                    calc_frais = false;
                }else{
                    total_basket += value_session.lunette.qte * (value_session.lunette.prix);
                }
                
                nb_item_total += value_session.lunette.qte;

                // ===== Calcul des frais VAD =====
                var montant_frais=0.00;
                if(gl_ems_config.data_cinema.frais_generaux.mode == 2){
                    montant_frais = gl_app.calc_fees_amount({
                        "frais_inclus" : gl_ems_config.data_cinema.frais_generaux.inclus,
                        "mode_frais" : gl_ems_config.data_cinema.frais_generaux.mode,
                        "total_frais" : gl_ems_config.data_cinema.frais_generaux.value,
                        "montant" : calc_frais ? gl_app.arrondi({"montant" : value_session.lunette.qte * value_session.lunette.prix}) : 0,
                        "qte" : value_session.lunette.qte
                    });
                }

                if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                    total_frais_basket += montant_frais;
                }else{
                    total_basket += montant_frais
                }

                $(".nb_lunet_3d_"+id_session).each(function(){
                    if(!value_session.lunette || value_session.lunette.qte==0){
                        $(this)[0].textContent = 0;
                        $(this).removeClass("active");
                        delete value_session.lunette;
                    }else{
                        $(this)[0].textContent = value_session.lunette.qte;
                        $(this).addClass("active");
                    }
                });
            }
        });

        $.each(this.data_basket.billetterie.superbillet,function(key_sb,value_sb){
            let id_sb = key_sb;
            let data_frais_tarif = {};
            data_frais_tarif.inclus = gl_ems_config.data_cinema.frais_generaux.inclus;
            data_frais_tarif.mode = gl_ems_config.data_cinema.frais_generaux.mode;
            data_frais_tarif.value = gl_ems_config.data_cinema.frais_generaux.value;
            if($(".nb_price_id_superbillet_"+id_sb).length>0){
                $(".nb_price_id_superbillet_"+id_sb).each(function(){
                    $(this)[0].textContent = value_sb.qte; 
                    if(value_sb.qte==0){
                        $(this).removeClass("active");
                    }else{
                        $(this).addClass("active");
                    }
                });
            }
            // total_basket += value_sb.qte * (value_sb.amount + value_sb.montant_majo_externe_tot); // la majo externe est déjà dans le amount du superbillet (différent que pour les séances standard)
            total_basket += value_sb.qte * (value_sb.amount);
            nb_item_total += value_sb.qte;

            // ===== Calcul des frais VAD =====
            var montant_frais = 0.00;
            montant_frais = gl_app.calc_fees_amount({
                "frais_inclus" : data_frais_tarif.inclus,
                "mode_frais" : data_frais_tarif.mode,
                "total_frais" : data_frais_tarif.value,
                // "montant" : gl_app.arrondi({"montant" : value_sb.qte * (value_sb.amount + value_sb.montant_majo_externe_tot)}),
                "montant" : gl_app.arrondi({"montant" : value_sb.qte * (value_sb.amount)}),
                "qte" : value_sb.qte
            });

            if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                total_frais_basket += montant_frais;
            }else{
                total_basket += montant_frais
            }

            if(value_sb.lunette && $(".nb_lunet_3d_"+id_sb).length>0){
                let calc_frais = true; 
                total_basket += value_sb.lunette.qte * (value_sb.lunette.prix);
                nb_item_total += value_sb.lunette.qte;

                // ===== Calcul des frais VAD =====
                var montant_frais=0.00;
                if(gl_ems_config.data_cinema.frais_generaux.mode == 2){
                    montant_frais = gl_app.calc_fees_amount({
                        "frais_inclus" : gl_ems_config.data_cinema.frais_generaux.inclus,
                        "mode_frais" : gl_ems_config.data_cinema.frais_generaux.mode,
                        "total_frais" : gl_ems_config.data_cinema.frais_generaux.value,
                        "montant" : calc_frais ? gl_app.arrondi({"montant" : value_sb.lunette.qte * value_sb.lunette.prix}) : 0,
                        "qte" : value_sb.lunette.qte
                    });
                }

                if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                    total_frais_basket += montant_frais;
                }else{
                    total_basket += montant_frais
                }

                $(".nb_lunet_3d_"+id_sb).each(function(){
                    if(!value_sb.lunette || value_sb.lunette.qte==0){
                        $(this)[0].textContent = 0;
                        $(this).removeClass("active");
                        delete value_sb.lunette;
                    }else{
                        $(this)[0].textContent = value_sb.lunette.qte;
                        $(this).addClass("active");
                    }
                });
            }            
        });
        
        $.each(this.data_basket.confiserie.product,function(key_conf_product,value_conf_product){
            let id_item = key_conf_product;

            if($(".nb_item_product_id_"+id_item).length>0){
                $(".nb_item_product_id_"+id_item).each(function(){
                    $(this)[0].textContent = value_conf_product.qte; 
                    if(value_conf_product.qte==0){
                        $(this).removeClass("active");
                    }else{
                        $(this).addClass("active");
                    }
                });
            }

            if(self.data_basket.confiserie.mode_payment == "CB"){
                total_basket += value_conf_product.qte * (value_conf_product.price);

                // ===== Calcul des frais VAD =====
                var montant_frais = 0.00;
                montant_frais = gl_app.calc_fees_amount({
                    "frais_inclus" : gl_ems_config.data_cinema.confiserie.frais.inclus,
                    "mode_frais" : gl_ems_config.data_cinema.frais_generaux.mode,
                    "total_frais" : gl_ems_config.data_cinema.confiserie.frais.value,
                    "montant" : gl_app.arrondi({"montant" : value_conf_product.qte * value_conf_product.price}),
                    "qte" : value_conf_product.qte
                });

                montant_frais = gl_app.arrondi({"montant" : montant_frais});

                if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                    total_frais_basket += parseFloat(montant_frais);
                }else{
                    total_basket += montant_frais
                }
            }
            nb_item_total += value_conf_product.qte;
        });

        $.each(this.data_basket.confiserie.menu,function(key_conf_menu,value_conf_menu){
            let id_item = key_conf_menu;
            $.each(value_conf_menu.ref_list,(k,v) => {
                if($(".nb_item_menu_id_"+k).length>0){
                    $(".nb_item_menu_id_"+k).each(function(){
                        $(this)[0].textContent = 1; 
                        if(value_conf_menu.qte==0){
                            $(this).removeClass("active");
                        }else{
                            $(this).addClass("active");
                        }
                    });
                }
            });
            if($(".nb_item_menu_id_"+value_conf_menu.id).length>0){
                $(".nb_item_menu_id_"+value_conf_menu.id).each(function(){
                    $(this)[0].textContent = value_conf_menu.qte; 
                    if(value_conf_menu.qte==0){
                        $(this).removeClass("active");
                    }else{
                        $(this).addClass("active");
                    }
                });
            }

            if(self.data_basket.confiserie.mode_payment == "CB"){
                total_basket += value_conf_menu.qte * (value_conf_menu.price);

                // ===== Calcul des frais VAD =====
                var montant_frais = 0.00;
                montant_frais = gl_app.calc_fees_amount({
                    "frais_inclus" : gl_ems_config.data_cinema.confiserie.frais.inclus,
                    "mode_frais" : gl_ems_config.data_cinema.frais_generaux.mode,
                    "total_frais" : gl_ems_config.data_cinema.confiserie.frais.value,
                    "montant" : gl_app.arrondi({"montant" : value_conf_menu.qte * value_conf_menu.price}),
                    "qte" : value_conf_menu.qte
                });

                montant_frais = gl_app.arrondi({"montant" : montant_frais});

                if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                    total_frais_basket += parseFloat(montant_frais);
                }else{
                    total_basket += montant_frais
                }
            }
            nb_item_total += value_conf_menu.qte;
        });

        if(!is_empty({"obj":this.data_basket.recharge})){
            total_basket += this.data_basket.recharge.total;
            nb_item_total += 1;

            // ===== Calcul des frais VAD =====
            var montant_frais=0.00;
            montant_frais = gl_app.calc_fees_amount({
                "frais_inclus" : gl_ems_config.data_cinema.frais_generaux.inclus,
                "mode_frais" : gl_ems_config.data_cinema.frais_generaux.mode,
                "total_frais" : gl_ems_config.data_cinema.frais_generaux.value,
                // "montant" : gl_app.arrondi({"montant" : value_sb.qte * (value_sb.amount + value_sb.montant_majo_externe_tot)}),
                "montant" : gl_app.arrondi({"montant" : this.data_basket.recharge.total}),
                "qte" : 1
            });

            if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                total_frais_basket += montant_frais;
            }else{
                total_basket += montant_frais
            }
        }

        if(!is_empty({"obj":this.data_basket.vente_carte})){
            total_basket += this.data_basket.vente_carte.total;
            nb_item_total += 1;

            // ===== Calcul des frais VAD =====
            var montant_frais=0.00;
            montant_frais = gl_app.calc_fees_amount({
                "frais_inclus" : gl_ems_config.data_cinema.frais_generaux.inclus,
                "mode_frais" : gl_ems_config.data_cinema.frais_generaux.mode,
                "total_frais" : gl_ems_config.data_cinema.frais_generaux.value,
                // "montant" : gl_app.arrondi({"montant" : this.data_basket.vente_carte.total + this.data_basket.vente_carte.frais_cine}),
                "montant" : gl_app.arrondi({"montant" : this.data_basket.vente_carte.total}),
                "qte" : 1
            });

            if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                total_frais_basket += montant_frais;
            }else{
                total_basket += montant_frais
            }

            // total_frais_basket += this.data_basket.vente_carte.frais_cine ? this.data_basket.vente_carte.frais_cine : 0;
        }

        if(!is_empty({"obj":this.data_basket.vente_carte_fidelite})){
            total_basket += this.data_basket.vente_carte_fidelite.total;
            nb_item_total += 1;

            // ===== Calcul des frais VAD =====
            var montant_frais=0.00;
            montant_frais = gl_app.calc_fees_amount({
                "frais_inclus" : gl_ems_config.data_cinema.frais_fidelity.inclus,
                "mode_frais" : gl_ems_config.data_cinema.frais_fidelity.mode,
                "total_frais" : gl_ems_config.data_cinema.frais_fidelity.value,
                "montant" : gl_app.arrondi({"montant" : this.data_basket.vente_carte_fidelite.total}),
                "qte" : 1
            });

            if(gl_ems_config.data_cinema.frais_generaux.affichage_separe){
                total_frais_basket += montant_frais;
            }else{
                total_basket += montant_frais
            }
        }

        // Si on est sur une carte abo qui a assez de solde argent, le total à payer est de 0
        // console.log(data_cm)
        if(data_cm && data_cm.type == 1){
            if(data_cm.illimite_argent || data_cm.solde_argent>=total_basket){
                total_basket = 0;
                total_frais_basket = 0;
            }
        }

        total_frais_basket = gl_app.arrondi({"montant" : total_frais_basket});

        this.data_basket.total_frais = parseFloat(total_frais_basket);
        this.data_basket.total += total_basket;
        this.data_basket.total += parseFloat(total_frais_basket);
        this.data_basket.nb_item_total = nb_item_total;

        this.data_basket.total = parseFloat(gl_app.arrondi({"montant" : this.data_basket.total}));

        // $(".block_total_basket").empty();
        // console.log(this.data_basket)
        if(this.data_basket.nb_item_total > 0){
            $(".block_total_basket").each((i,e) => {
                var $t = $(e);
                $t.empty();
                $t.show();
                var $flexbox=$("<div/>").addClass("d-flex").appendTo($t);
                    var $wrap=$("<div/>").addClass("d-flex justify-content-between").appendTo($flexbox);
                        var $label=$("<div/>").addClass("my-auto label").text(_l("Total à payer")).appendTo($wrap);
                        var $text=$("<div/>").addClass("amount").addClass("bold ms-2 ms-md-4 my-auto").text(currency_format(gl_ems_config.data_cinema.devise,this.data_basket.total,2)).appendTo($wrap);
                    var $wrap=$("<div/>").addClass("d-flex justify-content-end flex-1 pointer").appendTo($flexbox).on("click",() => {
                        self.validator();
                        // window.location.href = "#cart";
                    });
                        var $label=$("<div/>").addClass("label my-auto ms-auto text-center").text(_l("Continuer")).appendTo($wrap);
                        var $svg_container = $("<div/>").addClass("svg_container icon icon_svg ms-2 my-auto").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_arrow_right")[0].svg_text).appendTo($wrap);
            });
            // maj du nombre d'article dans la pastille du panier (navbar)
            $("nav a#cart .nb_item_basket").addClass("active").text(this.data_basket.nb_item_total);
            $(".mobile-app-footer #box_basket .nb_item_basket").addClass("active").text(this.data_basket.nb_item_total);
        }else{
            $(".block_total_basket").hide();
            $("nav a#cart .nb_item_basket").removeClass("active").text(0);
            $(".mobile-app-footer #box_basket .nb_item_basket").removeClass("active").text(0);
        }

        if($(".charges_amount").length > 0){
            $(".charges_amount")[0].textContent = currency_format(gl_ems_config.data_cinema.devise,total_frais_basket,2)
        }
        if($(".majos_amount").length > 0){
            $(".majos_amount")[0].textContent = currency_format(gl_ems_config.data_cinema.devise,total_majo_cm,2)
        }
        if($(".total_amount").length > 0){
            $(".total_amount")[0].textContent = currency_format(gl_ems_config.data_cinema.devise,this.data_basket.total,2)
        }

        this.nb_waiting_seats = 0;
        $.each(this.data_basket.waiting_seats,(key,value) => {
            switch(key){
                case "session":
                    // ===== On boucle sur chaque séance =====
                    $.each(value,(key,value) => {
                        this.nb_waiting_seats += value.seats.length;
                    });
                    break;
                case "superbillet":
                    $.each(value,(key,value) => {
                        $.each(value.list_session,(key, value) => {
                            this.nb_waiting_seats += value.seats.length;
                        })
                    });
                    break;
                default:
                    break;
            }
        });
    }

    async select_seat(iParam) {
        // console.log("===== EMSBasket.select_seat =====", iParam)
        const seat_info = iParam.seat_info;
        const is_session = seat_info.is_session;
        const is_superbillet = seat_info.is_superbillet;
        const data_session = seat_info.data_session;
        const data_superbillet = seat_info.data_superbillet;
        const $seat = seat_info.element;
        let id_price = null;
        let section_OK=true;

        let session_id = data_session ? data_session.ems_id : null;
        let superbillet_id = data_superbillet ? data_superbillet.id : null;

        let nb_seats_session = 0;
        let nb_seats_already_choosen = 0;

        let add_to_waiting_seats = false;

        if(is_session){
            if(this.data_basket.billetterie.session && this.data_basket.billetterie.session[session_id]){
                nb_seats_already_choosen=this.data_basket.billetterie.session[session_id].seats.length;
            
                // ===== On boucle sur chaque tarif =====
                $.each(this.data_basket.billetterie.session[session_id].tarif,(key,value) => {
                    nb_seats_session+=value.qte;
                });
            }
        }else if(is_superbillet){
            if(this.data_basket.billetterie.superbillet && this.data_basket.billetterie.superbillet[superbillet_id]){
                nb_seats_already_choosen=this.data_basket.billetterie.superbillet[superbillet_id].list_session[session_id].seats.length;
                nb_seats_session=this.data_basket.billetterie.superbillet[superbillet_id].qte;
            }
        }

        if(nb_seats_session>0){
            if(nb_seats_already_choosen < nb_seats_session){
                // ===== On récupère les sections tarifaires pour la séance concernées =====
                var sections_invalid_prices=null;

                if(is_session){
                    // ===== On boucle sur chaque tarif afin de vérifier si ils sont déjà affectés à un siège =====
                    $.each(this.data_basket.billetterie.session[session_id].tarif,function(key,value){
                        id_price=parseInt(key);
                        var nb_seats_by_price=value.seats;
                        var nb_price=value.qte;
                        
                        sections_invalid_prices=value.section_plan_salle_tarif;

                        // ===== Si il reste des tarifs sans siège et si il y a des sections tarifaires =====
                        if((nb_price>nb_seats_by_price.length)){
                            if(sections_invalid_prices!==undefined && sections_invalid_prices!==null){
                                // ===== Si on trouve l'id du tarif dans la section invalid, cela signifie que le tarif n'y est pas autorisé =====
                                if(sections_invalid_prices.indexOf(seat_info.seat_section)>=0){
                                    section_OK=false;
                                }
                                return false; // On arrête la boucle les tarifs
                            }else{
                                return false; // On arrête la boucle les tarifs
                            }
                        }
                    });
                }

                if(section_OK){
                    var seats_in_bakset=[];
                    var seats_by_price=[];

                    if(is_session){
                        seats_in_bakset=this.data_basket.billetterie.session[session_id].seats;
                        seats_by_price=this.data_basket.billetterie.session[session_id].tarif[id_price].seats;

                        seats_in_bakset.push(seat_info.seat_name);
                        seats_by_price.push(seat_info.seat_name);

                        this.data_basket.billetterie.session[session_id].seats=seats_in_bakset;
                        this.data_basket.billetterie.session[session_id].tarif[id_price].seats=seats_by_price;
                    }else if(is_superbillet){
                        seats_in_bakset=this.data_basket.billetterie.superbillet[superbillet_id].seats;
                        seats_by_price=this.data_basket.billetterie.superbillet[superbillet_id].list_session[session_id].seats;

                        seats_in_bakset.push(seat_info.seat_name);
                        seats_by_price.push(seat_info.seat_name);

                        this.data_basket.billetterie.superbillet[superbillet_id].seats=seats_in_bakset;
                        this.data_basket.billetterie.superbillet[superbillet_id].list_session[session_id].seats=seats_by_price;
                    }                        

                    $seat.addClass("selected");
                    switch(seat_info.type){
                        case "duo_left":
                        case 5:
                            $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/selected_duo_left_seat.png"});
                            break;
                        case "duo_right":
                        case 6:
                            $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/selected_duo_right_seat.png"});
                            break;
                        case "couch":
                        case 7:
                            $seat.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/selected_couch.png"});
                            break;
                        default:
                            $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/selected_seat.png"});
                            break;
                    }
                }else{
                    Swal.fire({
                        icon:"info",
                        title:"",
                        text: _l("Le siège sélectionné ne fait pas partie de la section autorisée pour le tarif que vous avez choisi."),
                        showCloseButton : true,
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : true,
                        customClass: {
                            icon : "align-items-center"
                        }
                    });
                    return;
                }
            }else{
                add_to_waiting_seats = true;
                // Swal.fire({
                //     icon:"info",
                //     title:"",
                //     text: _l("Vous avez sélectionné tous vos sièges."),
                //     showCloseButton : true,
                //     heightAuto : false,
                //     scrollbarPadding : false,
                //     allowOutsideClick : true,
                //     customClass: {
                //         icon : "align-items-center"
                //     }
                // });
                // return;
            }
        }else{
            add_to_waiting_seats = true;
            // Swal.fire({
            //     icon:"info",
            //     title:"",
            //     text: _l("Veuillez ajouter un ou plusieurs tarifs avant de pouvoir sélectionner vos sièges."),
            //     showCloseButton : true,
            //     heightAuto : false,
            //     scrollbarPadding : false,
            //     allowOutsideClick : true,
            //     customClass: {
            //         icon : "align-items-center"
            //     }
            // });
            // return;
        }

        // Ajout des sièges dans un tableau 
        // A l'ajout d'un tarif on viendra piocher dans ce tableau 
        // Pour affecter un siège au tarif
        if(add_to_waiting_seats){
            let add_ok = false;
            var waiting_seats_in_basket=[];

            if(!this.data_basket.waiting_seats){
                this.data_basket.waiting_seats = {};
                this.data_basket.waiting_seats.session = {};
                this.data_basket.waiting_seats.superbillet = {};
            }

            if(is_session){
                if(!this.data_basket.waiting_seats.session[session_id]){
                    this.data_basket.waiting_seats.session[session_id] = {};
                    this.data_basket.waiting_seats.session[session_id].seats = [];
                }
                if(this.data_basket.waiting_seats.session[session_id].seats){
                    waiting_seats_in_basket=this.data_basket.waiting_seats.session[session_id].seats;
                }           
                if((nb_seats_already_choosen + waiting_seats_in_basket.length) >= this.nb_place_max_basket){
                    Swal.fire({
                        icon:"info",
                        title:"",
                        text: _l("Le nombre maximum de place pour un panier est atteind."),
                        showCloseButton : true,
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : true,
                        customClass: {
                            icon : "align-items-center"
                        }
                    });
                    return;
                }
                if(waiting_seats_in_basket.indexOf(seat_info.seat_name) < 0){
                    add_ok = true;
                    waiting_seats_in_basket.push(seat_info.seat_name);
                }
                this.data_basket.waiting_seats.session[session_id].seats=waiting_seats_in_basket;
            }else if(is_superbillet){
                if(!this.data_basket.waiting_seats.superbillet[superbillet_id]){
                    this.data_basket.waiting_seats.superbillet[superbillet_id] = {};
                    this.data_basket.waiting_seats.superbillet[superbillet_id].list_session = {};
                    // this.data_basket.waiting_seats.superbillet[superbillet_id].seats = [];
                }

                if(!this.data_basket.waiting_seats.superbillet[superbillet_id].list_session[session_id]){
                    this.data_basket.waiting_seats.superbillet[superbillet_id].list_session[session_id] = {};
                    this.data_basket.waiting_seats.superbillet[superbillet_id].list_session[session_id].seats = [];
                }

                if(this.data_basket.waiting_seats.superbillet[superbillet_id].list_session[session_id].seats){
                    waiting_seats_in_basket=this.data_basket.waiting_seats.superbillet[superbillet_id].list_session[session_id].seats;
                }                
                if(waiting_seats_in_basket.indexOf(seat_info.seat_name) < 0){
                    add_ok = true;
                    waiting_seats_in_basket.push(seat_info.seat_name);
                }
                this.data_basket.waiting_seats.superbillet[superbillet_id].list_session[session_id].seats=waiting_seats_in_basket;
            }   

            if(add_ok){
                $seat.addClass("selected");
                switch(seat_info.type){
                    case "duo_left":
                    case 5:
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/selected_duo_left_seat.png"});
                        break;
                    case "duo_right":
                    case 6:
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/selected_duo_right_seat.png"});
                        break;
                    case "couch":
                    case 7:
                        $seat.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/selected_couch.png"});
                        break;
                    default:
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/selected_seat.png"});
                        break;
                }
            }
        }

        this.end_process();
    }

    show_suggestions() {
        // console.log("show_suggestions", gl_ems_config.data_cinema.confiserie.data.suggestions)
        const self = this;
        let buttons = [];
        var tab_items_final = [];
        this.suggestions_already_show = true;
        
        let $content=$("<div/>").addClass("d-flex flex-wrap justify-content-center content").attr({"id":"content_suggestions"});
        if(gl_ems_config.data_cinema.confiserie.data.suggestions) {
            if(is_empty({"obj":this.data_basket.confiserie})){
                buttons.push({
                    class : "btn text-white bold my-1 m-auto",
                        title : _l("Voir tous les articles confiserie"),
                        preventClose : false,
                        action : () => {
                            window.location.href = "#showconfiserie";
                        }
                })
            }

            var tab_suggestions= Object.values(gl_ems_config.data_cinema.confiserie.data.suggestions);
            var tab_matched_suggestions=[];
            var tab_final_item_to_suggest=[];
            tab_items_final=[];
            var has_product_available=false;
            var tab_sold_in=[];
            var tab_sold_out=[];

            // ===== Tri des suggestions du fichier confiserie =====
            tab_suggestions.sort(function(a,b){
                if(a.order<b.order){
                    return -1;
                };
                if(a.order>b.order){
                    return 1;
                };
                return 0;
            });

            // ===== Première étape, on cherche les suggestions qui match =====
            for(var i=0;i<tab_suggestions.length;i++){
                var id_suggestion=tab_suggestions[i].id;
                var type_condition_suggestion=tab_suggestions[i].condition.type;
                var tab_products_condition_suggestion=tab_suggestions[i].condition.products;
                
                switch(type_condition_suggestion){
                    case "always":
                        // ===== Ajout de la suggestion si elle n'est pas déjà dans le tableau =====
                        if(tab_matched_suggestions.indexOf(id_suggestion)<0){
                            tab_matched_suggestions.push(id_suggestion);
                        }
                        break;
                    case "any_product":      // Si dans mon panier j'ai ajouté un article de la liste des produits de cette condition
                        if(!is_empty({"obj":this.data_basket.confiserie})){
                            // ===== Parcours des products =====
                            if(!is_empty({"obj":this.data_basket.confiserie.product})){
                                $.each(this.data_basket.confiserie.product,function(key,value){
                                    var id_product=parseInt(key);
                                    // ===== Si le produit de mon panier est dans le tableau des produits à suggérer =====
                                    if(tab_products_condition_suggestion.indexOf(id_product)>=0){
                                        // ===== Ajout de la suggestion si elle n'est pas déjà dans le tableau =====
                                        if(tab_matched_suggestions.indexOf(id_suggestion)<0){
                                            tab_matched_suggestions.push(id_suggestion);
                                        }
                                    }
                                });
                            };
                            
                            // ===== Parcours des menus =====
                            if(!is_empty({"obj":this.data_basket.confiserie.menu})){
                                $.each(this.data_basket.confiserie.menu,function(key,value){
                                    $.each(value.ref_list,function(key,value){
                                        $.each(value.products,function(key,value){
                                            var tab_ids=value.ids;
                                            for(var j=0;j<tab_ids.length;j++){
                                                var ids=tab_ids[j];
                                                // ===== Si le produit de mon menu est dans le tableau des produits à suggérer =====
                                                if(tab_products_condition_suggestion.indexOf(ids)>=0){
                                                // ===== Ajout de la suggestion si elle n'est pas déjà dans le tableau =====
                                                    if(tab_matched_suggestions.indexOf(id_suggestion)<0){
                                                        tab_matched_suggestions.push(id_suggestion);
                                                    }
                                                }
                                            }
                                        });
                                    });
                                });             
                            }
                        }
                        break;
                    case "empty_basket":    // Aucun article confiserie dans le panier
                        if(is_empty({"obj":this.data_basket.confiserie})){
                            // ===== Ajout de la suggestion si elle n'est pas déjà dans le tableau =====
                            if(tab_matched_suggestions.indexOf(id_suggestion)<0){
                                tab_matched_suggestions.push(id_suggestion);
                            }
                        }
                        break;
                    default:
                        break;
                }
            }
            
            // ===== Deuxième étape, on parcours les suggestions matchées =====
            for(var i=0;i<tab_matched_suggestions.length;i++){
                var id_suggestion=tab_matched_suggestions[i];
                // ===== Récupération des règles de cette suggestion =====
                for(var j=0;j<tab_suggestions.length;j++){
                    if(id_suggestion==tab_suggestions[j].id){
                        var tab_items_suggestion=tab_suggestions[j].items;
                        for(var k=0;k<tab_items_suggestion.length;k++){
                            var id_items_suggestion=tab_items_suggestion[k].id;
                            var add_item_ok=true;
                            // ===== On regarde si cet id n'est pas déjà présent dans le tableau final =====
                            for(var l=0;l<tab_final_item_to_suggest.length;l++){
                                if(tab_final_item_to_suggest[l].id==id_items_suggestion){
                                    add_item_ok=false;
                                    break;
                                }
                            }
                            // ===== On regarde si cet id n'est pas déjà présent dans notre panier =====
                            if(add_item_ok){
                                if(!is_empty({"obj":this.data_basket.confiserie})){
                                    // ===== Parcours des products =====
                                    if(!is_empty({"obj":this.data_basket.confiserie.product})){
                                        $.each(this.data_basket.confiserie.product,function(key,value){
                                            var id_product=key;

                                            if(id_items_suggestion==id_product){
                                                add_item_ok=false;
                                                return false;
                                            }
                                        });
                                    }
                                    // ===== Parcours des menus =====
                                    if(add_item_ok){
                                        if(!is_empty({"obj":this.data_basket.confiserie.menu})){
                                            $.each(this.data_basket.confiserie.menu,function(key,value){
                                                $.each(value.ref_list,function(key,value){
                                                    $.each(value.products,function(key,value){
                                                        var tab_ids=value.ids;
                                                        for(var l=0;l<tab_ids.length;l++){
                                                            var ids=tab_ids[l];
                                                            if(id_items_suggestion==ids){
                                                                add_item_ok=false;
                                                                return false;
                                                            }
                                                        }
                                                    });
                                                });
                                            });
                                        }
                                    }
                                }
                            }
                            // ===== Si on peut ajouter ce produit au suggestion =====
                            if(add_item_ok){
                                tab_final_item_to_suggest.push(tab_items_suggestion[k])
                            }
                        }
                    }
                }
            }

            // ===== Troisième étape, on parcours les produits à suggérer =====
            for(var i=0;i<tab_final_item_to_suggest.length;i++){
                var sold_out=false;
                var type_product_to_suggest=tab_final_item_to_suggest[i].type;
                var id_product_to_suggest=tab_final_item_to_suggest[i].id;
                var val=null;
                
                // ===== On va récupérer les infos du produits ou du menu =====
                switch(type_product_to_suggest){
                    case "menu":
                        // ===== Recherche des infos du menu =====
                        $.each(gl_ems_config.data_cinema.confiserie.data.menus,function(key,value){
                            if(id_product_to_suggest==key){
                                val=Object.assign({},value);
                                return false; // arrête la boucle
                            }
                        });
                        // ===== Si le cinéma n'autorise pas la vente en stock négatif, on check la liste des soldout =====
                        if(!gl_ems_config.data_cinema.confiserie.data.autorise_vente_negative){
                            for(var j=0;j<(val.products).length;j++){
                                var ids=val.products[j].ids;
                                var sold_in=false;
                                for(var k=0;k<ids.length;k++){
                                    // ===== Pour les menus, on regarde si au moins un des produits qui compose le menu est en stock =====
                                    if(gl_ems_config.data_cinema.confiserie.data.soldout.indexOf(ids[k])<0){
                                        sold_in=true;
                                        sold_out = false;
                                        break;
                                    }
                                    // ===== Si aucun produit qui compose le menu n'est en stock, le menu est soldout =====
                                    if(!sold_in){
                                        sold_out=true;
                                    }
                                }
                                if(sold_out){
                                    break;
                                }
                            }
                        }
                        break;
                    case "product":
                        // ===== Recherche des infos du produits =====
                        $.each(gl_ems_config.data_cinema.confiserie.data.products,function(key,value){
                            if(id_product_to_suggest==key){
                                val=Object.assign({},value);
                                return false; // arrête la boucle
                            }
                        });
                        
                        // ===== Si le cinéma n'autorise pas la vente en stock négatif, on check la liste des soldout =====
                        if(!gl_ems_config.data_cinema.confiserie.data.autorise_vente_negative){
                            if(gl_ems_config.data_cinema.confiserie.data.soldout.indexOf(id_product_to_suggest)>=0){
                                sold_out=true;
                            }
                        }
                        break;
                    default:
                        break;
                }

                if(val.img){
                    val.img = gl_ems_config.data_cinema.confiserie.data.product_image_url+val.img;
                    val.img = val.img.replace("/120","/240");
                }else{
                    // val.img="https://static.monnaie-services.com/www-img/ticketingcine/default_prd_confiserie.webp";
                    val.img="https://static.monnaie-services.com/www-img/ticketingcine/no_img_conf_imsweb.webp";
                }

                // ===== Calcul des frais =====
                var montant_frais=0.00;
                montant_frais=gl_app.calc_fees_amount({
                    frais_inclus: gl_ems_config.data_cinema.confiserie.frais.inclus,
                    mode_frais: gl_ems_config.data_cinema.frais_generaux.mode,
                    total_frais: gl_ems_config.data_cinema.confiserie.frais.value,
                    montant:parseFloat(val.price),
                    qte:1
                }); // js/custom/function.js

                val.total_price=gl_app.arrondi({
                    "montant":(val.price+montant_frais)
                });
                
                if(val && val!=null){
                    val.item_type=type_product_to_suggest;
                    if(sold_out){
                        val.is_sold_out=true;
                        tab_sold_out.push(val);
                    }else{
                        val.is_sold_out=false;
                        tab_sold_in.push(val);
                    }
                }
            }

            // ===== Affichage des produits en stock =====
            for(var i=0;i<tab_sold_in.length;i++){
                has_product_available=true;
                tab_items_final.push(tab_sold_in[i]);
            }

            // ===== Affichage des produits =====
            tab_items_final.forEach(item => {
                var $card=$("<div/>").addClass("d-flex flex-column box card_item_confiserie align-items-stretch position-relative").appendTo($content);
                    var $wrap=$("<div/>").addClass("wrap position-relative").appendTo($card);
                        var $qty=$("<div/>").addClass("qty nb_item nb_item_"+item.item_type+"_id_"+item.id).appendTo($wrap);
                        var $container_poster=$("<div/>").addClass("container_poster py-2 mt-auto d-flex").appendTo($wrap);
                            var $poster=$("<img/>").addClass("poster pointer mx-auto").attr({"src":item.img, "alt":item.label}).appendTo($container_poster);

                    if(!item.is_sold_out){
                        var price=gl_app.arrondi({
                            "montant":(item.total_price)
                        });
                        let text_price = currency_format(gl_ems_config.data_cinema.devise,price,2);
                        let tab_text_price = text_price.split(".");
                        var $container_price=$("<div/>").addClass("container_price d-flex").appendTo($container_poster);
                            var $text=$("<div/>").addClass("text my-auto").text(tab_text_price[0]).appendTo($container_price);
                            var $text=$("<div/>").addClass("text decimal").text(","+tab_text_price[1]).appendTo($container_price);

                        $card.addClass("pointer");
                        $card.on("click",function(){
                            gl_app.EMSConfiserie.select_item({
                                "data_item":item,
                                "elem_from" : $(this)
                            });
                        });
                    }else{
                        $card.addClass("sold_out");
                        var $disabled=$("<div/>").addClass("position-absolute top-0 start-0 w-100 h-100 disabled").appendTo($card);
                        var $div_phrase_soldout=$("<div/>").addClass("ct_phrase_soldout d-flex").appendTo($card)
                            var $phrase_soldout=$("<div/>").addClass("phrase_soldout my-auto p-1").text(_l("Epuisé")).appendTo($div_phrase_soldout);
                    } 

                    var $label=$("<div/>").addClass("label text-center mb-2").text(item.label).appendTo($card);
            });
        }else{
            const location_hash = gl_app.getHash();
            // console.log(location_hash)

            if(location_hash.hash != "showconfiserie" && is_empty({"obj":this.data_basket.confiserie})){
                var $row=$("<div/>").addClass("row w-100 justify-content-center").appendTo($content);
                    var $col=$("<div/>").addClass("col-11 col-md-6 col-xl-4").appendTo($row);
                        var $wrap=$("<div/>").addClass("d-flex position-relative").attr({"id":"wrap_img_confiserie"}).appendTo($col).on("click",() => {
                            // console.log(gl_app.getHash())
                            window.location.href = "#showconfiserie";
                        })
                            var $img=$("<img/>").addClass("p-1 m-auto").attr({"src":"https://static.monnaie-services.com/www-img/ticketingcine/popcorn.png","id":"img_confiserie", "alt":""}).appendTo($wrap);
                            var $text=$("<div/>").addClass("text").text(_l("Ajouter de la confiserie")).appendTo($wrap);
            }else{
                window.location.href = "#cart";
                return;
            }
        }

        if(tab_items_final.length <= 0){
            window.location.href = "#cart";
            return;
        }

        buttons.push({
            class : "bg-success text-white bold my-1 m-auto",
            title : _l("Finaliser mon achat"),
            preventClose : false,
            action : () => {
                window.location.href = "#cart";
            },
        });

        new MSModal({
            buttons : buttons,
            has_close_box : false,
            html : $content,
            option : {
                dialog : {
                    class : "modal-dialog-centered modal-xl modal-dialog-scrollable"
                },
                title : {
                    class : "h2"
                }
            },
            title : _l("Voici nos suggestions"),
        })
        .open();
    }

    async unselect_seat(iParam) {
        // console.log("===== EMSBasket.unselect_seat =====", iParam)
        let seat_info = iParam.seat_info;
        const is_session = seat_info.is_session;
        const is_superbillet = seat_info.is_superbillet;
        const data_session = seat_info.data_session;
        const data_superbillet = seat_info.data_superbillet;
        const $seat = seat_info.element;
        let id_price = null;

        let session_id = data_session ? data_session.ems_id : null;
        let superbillet_id = data_superbillet ? data_superbillet.id : null;

        if((is_session && this.data_basket.billetterie.session && this.data_basket.billetterie.session[session_id]) || (is_superbillet && this.data_basket.billetterie.superbillet && this.data_basket.billetterie.superbillet[superbillet_id])){
            var seats_in_bakset=[];
            var seats_by_price=[];

            if(is_session){
                seats_in_bakset=this.data_basket.billetterie.session[session_id].seats;
            }
            if(is_superbillet){
                seats_in_bakset=this.data_basket.billetterie.superbillet[superbillet_id].seats;
            }

            // ===== On supprime le siège du tableau pour la séance concernée =====
            for(var i=0;i<seats_in_bakset.length;i++){
                if(seats_in_bakset[i]==seat_info.seat_name){
                    seats_in_bakset.splice(i,1);
                    break;
                }
            }

            if(is_session){
                this.data_basket.billetterie.session[session_id].seats=seats_in_bakset;
                // ===== On supprime le siège du tableau des tarifs pour la séance concernée =====
                $.each(this.data_basket.billetterie.session[session_id].tarif,(key,value) => {
                    id_price=parseInt(key);
                    var seats_by_price=value.seats;
                    for(var i=0;i<seats_by_price.length;i++){
                        if(seats_by_price[i]==seat_info.seat_name){
                            seats_by_price.splice(i,1);
                            break;
                        }
                    }
                    this.data_basket.billetterie.session[session_id].tarif[id_price].seats=seats_by_price;
                });
            }else if(is_superbillet){
                this.data_basket.billetterie.superbillet[superbillet_id].seats=seats_in_bakset;
                // ===== On supprime le siège du tableau de la séance concernée =====
                $.each(this.data_basket.billetterie.superbillet[superbillet_id].list_session,(key,value) => {
                    var id_session_temp=parseInt(key);
                    var seats_by_price=value.seats;
                    for(var i=0;i<seats_by_price.length;i++){
                        if(seats_by_price[i]==seat_info.seat_name){
                            seats_by_price.splice(i,1);
                            break;
                        }
                    }
                    this.data_basket.billetterie.superbillet[superbillet_id].list_session[id_session_temp].seats=seats_by_price;
                });
            }
        }else{
            // Retrait des waiting seat
            let remove_ok = false;
            var waiting_seats_in_basket=[];
            if(is_session){
                if(this.data_basket.waiting_seats && this.data_basket.waiting_seats.session && this.data_basket.waiting_seats.session[session_id] && this.data_basket.waiting_seats.session[session_id].seats){
                    waiting_seats_in_basket = this.data_basket.waiting_seats.session[session_id].seats;
                    const i_waiting_seat = waiting_seats_in_basket.indexOf(seat_info.seat_name);
                    if(i_waiting_seat >= 0){
                        waiting_seats_in_basket.splice(i_waiting_seat,1)
                        remove_ok = true
                    }
                    if(waiting_seats_in_basket.length <= 0){
                        delete this.data_basket.waiting_seats.session[session_id];
                    }
                }
            }else if(is_superbillet){
                if(this.data_basket.waiting_seats && this.data_basket.waiting_seats.superbillet && this.data_basket.waiting_seats.superbillet[superbillet_id] && this.data_basket.waiting_seats.superbillet[superbillet_id].list_session[session_id].seats){
                    waiting_seats_in_basket = this.data_basket.waiting_seats.superbillet[superbillet_id].list_session[session_id].seats;
                    const i_waiting_seat = waiting_seats_in_basket.indexOf(seat_info.seat_name);
                    if(i_waiting_seat >= 0){
                        waiting_seats_in_basket.splice(i_waiting_seat,1)
                        remove_ok = true
                    }
                    if(waiting_seats_in_basket.length <= 0){
                        delete this.data_basket.waiting_seats.superbillet[superbillet_id].list_session[session_id];
                    }
                }
            }

            if(remove_ok && $seat!==undefined){
                $seat.removeClass("selected");
                // ===== On remet l'image de base pour le siège désélectionné =====
                switch(seat_info.type){
                    case "APMR":
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/APMR_seat.png"});
                        break;
                    case "PMR":
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/PMR_seat.png"});
                        break;
                    case "standard":
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/free_seat.png"});
                        break;
                    case "strapontin":
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/free_seat.png"});
                        break;
                    case "DUO" : 
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/duo_seat.png"});
                        break;
                    case "duo_left":
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/duo_left_seat.png"});
                        break;
                    case "duo_right":
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/duo_right_seat.png"});
                        break;
                    case "couch":
                    case 7:
                        $seat.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/couch.png"});
                        break;
                    default:
                        $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/free_seat.png"});
                        break;
                }
            }
        }

        if($seat!==undefined){
            $seat.removeClass("selected");
            // ===== On remet l'image de base pour le siège désélectionné =====
            switch(seat_info.type){
                case "APMR":
                    $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/APMR_seat.png"});
                    break;
                case "PMR":
                    $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/PMR_seat.png"});
                    break;
                case "standard":
                    $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/free_seat.png"});
                    break;
                case "strapontin":
                    $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/free_seat.png"});
                    break;
                case "DUO" : 
                    $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/duo_seat.png"});
                    break;
                case "duo_left":
                case 5:
                    $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/duo_left_seat.png"});
                    break;
                case "duo_right":
                case 6:
                    $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/duo_right_seat.png"});
                    break;
                case "couch":
                case 7:
                    $seat.attr({"src": "https://static.monnaie-services.com/www-img/hall_map/couch.png"});
                    break;
                default:
                    $seat.attr({"src":"https://static.monnaie-services.com/www-img/hall_map/free_seat.png"});
                    break;
            }
        }

        this.end_process();
    }

    update_basket(iParam) {
        // console.log("update_basket", iParam)
        this.data_basket = iParam;
    }

    validator(){
        const self = this;
        let validator_ok = true;
        let is_basket_ok = true;
        if(!(is_empty({"obj":this.data_basket.billetterie})) || !(is_empty({"obj":this.data_basket.confiserie})) || !(is_empty({"obj":this.data_basket.recharge})) || !(is_empty({"obj":this.data_basket.vente_carte})) || !(is_empty({"obj":this.data_basket.vente_carte_fidelite}))){
            // ===== Parcours et vérification du panier =====
            $.each(this.data_basket,(key,value) => {
                switch(key){
                    case "billetterie":
                        if(!(is_empty({"obj":value}))){
                            $.each(value,function(key,value){
                                switch(key){
                                    case "session":
                                        // ===== On boucle sur chaque séance =====
                                        $.each(value,function(key,value){
                                            var nb_tarif_session=0;

                                            var id_session=key;
                                            var id_film=value.id_film;
                                            var list_seats=value.seats;
                                            // var nb_waiting_seats_session = 0;
                                            // if(self.data_basket.waiting_seats && self.data_basket.waiting_seats.session && self.data_basket.waiting_seats.session[id_session] && self.data_basket.waiting_seats.session[id_session].seats){
                                            //     nb_waiting_seats_session = self.data_basket.waiting_seats.session[id_session].seats.length;
                                            // }

                                            // ===== On boucle sur chaque tarif =====
                                            $.each(value.tarif,function(key,value){
                                                nb_tarif_session+=value.qte;
                                            });

                                            // ===== Si plan de salle et que les sièges ne sont pas tous choisis =====                                         
                                            if(value.seat_booking){
                                                // console.log(value)
                                                if(list_seats.length!=nb_tarif_session){
                                                    var data={};
                                                    data.id_session=id_session;
                                                    data.id_film=id_film;
                                                    data.nb=nb_tarif_session;
                                                    data.list_seats=list_seats;

                                                    let movie_title = value.data_session.data_ms.title;

                                                    Swal.fire({
                                                        icon:"info",
                                                        title:"",
                                                        html : 
                                                        '<div class="mb-3">Vous n'+"'"+'avez pas sélectionné tous vos sièges pour la séance suivante</div>'+
                                                        '<div class="mb-3 bold">'+movie_title+'</div>'+
                                                        '<div class="mb-3 bold">'+moment(value.data_session.date.substr(0,8)).format("DD/MM/YYYY")+' - '+value.data_session.date.substr(8,2)+'h'+value.data_session.date.substr(10,2)+'</div>',
                                                        heightAuto : false,
                                                        scrollbarPadding : false,
                                                        allowOutsideClick : true,
                                                        customClass: {
                                                            icon : "align-items-center"
                                                        }
                                                    }); // js/plugins/sweetalert2.js 

                                                    validator_ok=false;
                                                    is_basket_ok=false;

                                                    return false; // On arrête la boucle sur le panier
                                                }

                                                if(self.data_basket.waiting_seats && self.data_basket.waiting_seats.session && self.data_basket.waiting_seats.session[id_session] && self.data_basket.waiting_seats.session[id_session].seats.length > 0){
                                                    var data={};
                                                    data.id_session=id_session;
                                                    data.id_film=id_film;
                                                    data.nb=nb_tarif_session;
                                                    data.list_seats=list_seats;

                                                    let movie_title = value.data_session.data_ms.title;

                                                    Swal.fire({
                                                        icon:"info",
                                                        title:"",
                                                        html : 
                                                        '<div class="mb-3">Vous avez sélectionné plus de sièges que de tarifs pour la séance suivante</div>'+
                                                        '<div class="mb-3 bold">'+movie_title+'</div>'+
                                                        '<div class="mb-3 bold">'+moment(value.data_session.date.substr(0,8)).format("DD/MM/YYYY")+' - '+value.data_session.date.substr(8,2)+'h'+value.data_session.date.substr(10,2)+'</div>',
                                                        heightAuto : false,
                                                        scrollbarPadding : false,
                                                        allowOutsideClick : true,
                                                        customClass: {
                                                            icon : "align-items-center"
                                                        }
                                                    }); // js/plugins/sweetalert2.js 

                                                    validator_ok=false;
                                                    is_basket_ok=false;

                                                    return false; // On arrête la boucle sur le panier
                                                }
                                            }

                                            // ===== Si le cinéma vends de la conf et qu'il y a des suggestions =====
                                            if(is_basket_ok && (gl_ems_config.data_cinema.confiserie.active) && !self.suggestions_already_show){
                                                validator_ok=false;
                                                return false;
                                            }
                                        });
                                        break;
                                    case "superbillet":
                                        $.each(value,function(key,value){
                                            var id_superbillet=key;
                                            var qte=value.qte;
                                            var type_payment=value.type_payment;

                                            var list_seats=value.seats;
                                            var nb_tarif_session=value.nb_session;

                                            // ===== Parcours de toutes les séances du superbillet pour savoir si il y a du plan de salle =====
                                            $.each(value.list_session,function(key,value){
                                                // ===== Si plan de salle et que les sièges ne sont pas tous choisis =====
                                                if(value.seat_booking && (value.seats.length!=qte)){
                                                    var data={};

                                                    data.id_superbillet=id_superbillet;
                                                    data.id_session=value.id_session;
                                                    data.id_film=value.id_movie;
                                                    data.nb=qte;
                                                    data.list_seats=value.seats;

                                                    Swal.fire({
                                                        icon:"info",
                                                        title:"",
                                                        text:"Le nombre de siège ne corresponds pas au nombre de billet dans votre panier, pensez à vérifier chaques séances.",
                                                        heightAuto : false,
                                                        scrollbarPadding : false,
                                                        allowOutsideClick : true,
                                                        customClass: {
                                                            icon : "align-items-center"
                                                        }
                                                    }); // js/plugins/sweetalert2.js 

                                                    validator_ok=false;
                                                    is_basket_ok=false;

                                                    return false; // On arrête la boucle sur le panier
                                                }
                                            });

                                            // ===== Si le cinéma vends de la conf et qu'il y a des suggestions =====
                                            if(is_basket_ok && (gl_ems_config.data_cinema.confiserie.active) && !self.suggestions_already_show){
                                                validator_ok=false;
                                                return false; 
                                            }
                                        });
                                        break;
                                    default:
                                        break;
                                }
                            });                            
                            return false; // on arrête le parcours du panier
                        }
                        break;
                    case "confiserie":
                        if(!(is_empty({"obj":this.data_basket.confiserie}))){
                            // ===== Si il y a des suggestions =====
                            if(!self.suggestions_already_show){
                                validator_ok=false;
                                return false;  // On arrête la boucle sur le panier
                                // if(gl_ems_config.data_cinema.confiserie.data.suggestions && gl_ems_config.data_cinema.confiserie.data.suggestions!=null){
                                //     validator_ok=false;
                                //     return false;  // On arrête la boucle sur le panier
                                // }
                            }
                        }
                        break;
                    case "recharge":
                        if(!(is_empty({"obj":this.data_basket.recharge}))){
                            if(!(is_empty({"obj":this.data_basket.billetterie})) || !(is_empty({"obj":this.data_basket.confiserie})) || !(is_empty({"obj":this.data_basket.vente_carte})) || !(is_empty({"obj":this.data_basket.vente_carte_fidelite}))){
                                validator_ok=false;

                                Swal.fire({
                                    icon:"info",
                                    title:"",
                                    text: _l("Votre panier contient un autre article non cumulable avec celui-ci, veuillez d'abord solder/annuler ce panier avant de continuer."),
                                    showCloseButton : true,
                                    reverseButtons : true,
                                    showCancelButton: false,
                                    showDenyButton : true,
                                    confirmButtonText:_l("Voir mon panier"),
                                    denyButtonText : _l("Annuler mon panier"),
                                    heightAuto : false,
                                    scrollbarPadding : false,
                                    allowOutsideClick : true,
                                    customClass: {
                                        icon : "align-items-center"
                                    }
                                }).then(function(result){
                                    if(result.isConfirmed){
                                        window.location.href = "#cart";
                                    }else if(result.isDenied){
                                        self.raz();
                                        window.location.replace("#home");
                                    }
                                });
                                return;
                            }
                        }
                        break;
                    case "vente_carte": 
                        if(!(is_empty({"obj":this.data_basket.vente_carte}))){
                            if(!(is_empty({"obj":this.data_basket.billetterie})) || !(is_empty({"obj":this.data_basket.confiserie})) || !(is_empty({"obj":this.data_basket.recharge})) || !(is_empty({"obj":this.data_basket.vente_carte_fidelite}))){
                                validator_ok=false;

                                Swal.fire({
                                    icon:"info",
                                    title:"",
                                    text: _l("Votre panier contient un autre article non cumulable avec celui-ci, veuillez d'abord solder/annuler ce panier avant de continuer."),
                                    showCloseButton : true,
                                    reverseButtons : true,
                                    showCancelButton: false,
                                    showDenyButton : true,
                                    confirmButtonText:_l("Voir mon panier"),
                                    denyButtonText : _l("Annuler mon panier"),
                                    heightAuto : false,
                                    scrollbarPadding : false,
                                    allowOutsideClick : true,
                                    customClass: {
                                        icon : "align-items-center"
                                    }
                                }).then(function(result){
                                    if(result.isConfirmed){
                                        window.location.href = "#cart";
                                    }else if(result.isDenied){
                                        self.raz();
                                        window.location.replace("#home");
                                    }
                                });
                                return;
                            }
                        }
                        break;
                    case "vente_carte_fidelite":
                        if(!(is_empty({"obj":this.data_basket.vente_carte_fidelite}))){
                            if(!(is_empty({"obj":this.data_basket.billetterie})) || !(is_empty({"obj":this.data_basket.confiserie})) || !(is_empty({"obj":this.data_basket.recharge})) || !(is_empty({"obj":this.data_basket.vente_carte}))){
                                validator_ok=false;

                                Swal.fire({
                                    icon:"info",
                                    title:"",
                                    text: _l("Votre panier contient un autre article non cumulable avec celui-ci, veuillez d'abord solder/annuler ce panier avant de continuer."),
                                    showCloseButton : true,
                                    reverseButtons : true,
                                    showCancelButton: false,
                                    showDenyButton : true,
                                    confirmButtonText:_l("Voir mon panier"),
                                    denyButtonText : _l("Annuler mon panier"),
                                    heightAuto : false,
                                    scrollbarPadding : false,
                                    allowOutsideClick : true,
                                    customClass: {
                                        icon : "align-items-center"
                                    }
                                }).then(function(result){
                                    if(result.isConfirmed){
                                        window.location.href = "#cart";
                                    }else if(result.isDenied){
                                        self.raz();
                                        window.location.replace("#home");
                                    }
                                });
                                return;
                            }
                        }
                        break;
                    default:
                        break;
                }
            });

            if(validator_ok){                
                window.location.href = "#cart";
            } else if((gl_ems_config.data_cinema.confiserie && gl_ems_config.data_cinema.confiserie.active) && !this.suggestions_already_show){
                this.show_suggestions();
                return;
            }
        }
    }
}